require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.find");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es7.object.entries");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

!function (n, e) {
  "object" == typeof exports && "undefined" != typeof module ? e(exports, require("@tinacms/react-core"), require("react"), require("@tinacms/icons"), require("@tinacms/form-builder"), require("styled-components"), require("@tinacms/styles"), require("react-dismissible"), require("react-beautiful-dnd"), require("react-dom"), require("@tinacms/fields"), require("react-datetime"), require("moment"), require("@tinacms/forms"), require("@tinacms/core")) : "function" == typeof define && define.amd ? define(["exports", "@tinacms/react-core", "react", "@tinacms/icons", "@tinacms/form-builder", "styled-components", "@tinacms/styles", "react-dismissible", "react-beautiful-dnd", "react-dom", "@tinacms/fields", "react-datetime", "moment", "@tinacms/forms", "@tinacms/core"], e) : e((n = n || self).tinacms = {}, n.reactCore, n.React, n.icons, n.formBuilder, n.styled, n.styles, n.reactDismissible, n.reactBeautifulDnd, n.reactDom, n.fields, n.ReactDatetime, n.moment, n.forms, n.core);
}(this, function (e, d, p, u, c, l, f, m, g, r, o, s, i, a, n) {
  "use strict";

  var t = "default" in l ? l["default"] : l;

  function h() {
    return d.useCMS();
  }

  s = s && s.hasOwnProperty("default") ? s["default"] : s, i = i && i.hasOwnProperty("default") ? i["default"] : i;

  var _b = function b(n, e) {
    return (_b = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (n, e) {
      n.__proto__ = e;
    } || function (n, e) {
      for (var t in e) {
        e.hasOwnProperty(t) && (n[t] = e[t]);
      }
    })(n, e);
  };

  function x(n, e) {
    function t() {
      this.constructor = n;
    }

    _b(n, e), n.prototype = null === e ? Object.create(e) : (t.prototype = e.prototype, new t());
  }

  var _v = function v() {
    return (_v = Object.assign || function (n) {
      for (var e, t = 1, r = arguments.length; t < r; t++) {
        for (var o in e = arguments[t]) {
          Object.prototype.hasOwnProperty.call(e, o) && (n[o] = e[o]);
        }
      }

      return n;
    }).apply(this, arguments);
  };

  function w(n, e) {
    var t = {};

    for (var r in n) {
      Object.prototype.hasOwnProperty.call(n, r) && e.indexOf(r) < 0 && (t[r] = n[r]);
    }

    if (null != n && "function" == typeof Object.getOwnPropertySymbols) {
      var o = 0;

      for (r = Object.getOwnPropertySymbols(n); o < r.length; o++) {
        e.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(n, r[o]) && (t[r[o]] = n[r[o]]);
      }
    }

    return t;
  }

  function y(i, a, l, s) {
    return new (l = l || Promise)(function (n, e) {
      function t(n) {
        try {
          o(s.next(n));
        } catch (n) {
          e(n);
        }
      }

      function r(n) {
        try {
          o(s["throw"](n));
        } catch (n) {
          e(n);
        }
      }

      function o(e) {
        e.done ? n(e.value) : new l(function (n) {
          n(e.value);
        }).then(t, r);
      }

      o((s = s.apply(i, a || [])).next());
    });
  }

  function k(t, r) {
    var o,
        i,
        a,
        n,
        l = {
      label: 0,
      sent: function sent() {
        if (1 & a[0]) throw a[1];
        return a[1];
      },
      trys: [],
      ops: []
    };
    return n = {
      next: e(0),
      "throw": e(1),
      "return": e(2)
    }, "function" == typeof Symbol && (n[Symbol.iterator] = function () {
      return this;
    }), n;

    function e(e) {
      return function (n) {
        return function (e) {
          if (o) throw new TypeError("Generator is already executing.");

          for (; l;) {
            try {
              if (o = 1, i && (a = 2 & e[0] ? i["return"] : e[0] ? i["throw"] || ((a = i["return"]) && a.call(i), 0) : i.next) && !(a = a.call(i, e[1])).done) return a;

              switch (i = 0, a && (e = [2 & e[0], a.value]), e[0]) {
                case 0:
                case 1:
                  a = e;
                  break;

                case 4:
                  return l.label++, {
                    value: e[1],
                    done: !1
                  };

                case 5:
                  l.label++, i = e[1], e = [0];
                  continue;

                case 7:
                  e = l.ops.pop(), l.trys.pop();
                  continue;

                default:
                  if (!(a = 0 < (a = l.trys).length && a[a.length - 1]) && (6 === e[0] || 2 === e[0])) {
                    l = 0;
                    continue;
                  }

                  if (3 === e[0] && (!a || e[1] > a[0] && e[1] < a[3])) {
                    l.label = e[1];
                    break;
                  }

                  if (6 === e[0] && l.label < a[1]) {
                    l.label = a[1], a = e;
                    break;
                  }

                  if (a && l.label < a[2]) {
                    l.label = a[2], l.ops.push(e);
                    break;
                  }

                  a[2] && l.ops.pop(), l.trys.pop();
                  continue;
              }

              e = r.call(t, l);
            } catch (n) {
              e = [6, n], i = 0;
            } finally {
              o = a = 0;
            }
          }

          if (5 & e[0]) throw e[1];
          return {
            value: e[0] ? e[1] : void 0,
            done: !0
          };
        }([e, n]);
      };
    }
  }

  function E(n, e) {
    return Object.defineProperty ? Object.defineProperty(n, "raw", {
      value: e
    }) : n.raw = e, n;
  }

  function P(n) {
    var e = n.forms,
        t = n.setActiveFormId,
        r = n.isEditing;
    return p.createElement(H, {
      isEditing: r
    }, e.sort(D).map(function (n) {
      return p.createElement(T, {
        key: n.id,
        onClick: function onClick() {
          return t(n.id);
        }
      }, p.createElement("span", null, n.label), p.createElement(u.RightArrowIcon, null));
    }));
  }

  var z,
      C,
      F,
      S,
      O = function O(n) {
    var e = n.actions,
        t = n.form,
        r = p.useState(!1),
        o = r[0],
        i = r[1];
    return p.createElement(p.Fragment, null, p.createElement(j, {
      onClick: function onClick() {
        return i(function (n) {
          return !n;
        });
      }
    }), p.createElement(I, {
      open: o
    }, p.createElement(m.Dismissible, {
      click: !0,
      escape: !0,
      disabled: !o,
      onDismiss: function onDismiss() {
        i(function (n) {
          return !n;
        });
      }
    }, e.map(function (n) {
      return p.createElement(n, {
        form: t
      });
    }))));
  },
      j = t(function (n) {
    return p.createElement("button", _v({}, n), p.createElement(u.EllipsisVerticalIcon, null));
  })(z = z || E(["\n  height: 100%;\n  width: 40px;\n  background-color: transparent;\n  background-position: center;\n  background-size: auto 18px;\n  background-repeat: no-repeat;\n  border: 0;\n  margin: 0 -16px 0 8px;\n  outline: none;\n  cursor: pointer;\n  transition: opacity 85ms ease-out;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  &:hover {\n    background-color: #f6f6f9;\n    fill: ", ";\n  }\n"], ["\n  height: 100%;\n  width: 40px;\n  background-color: transparent;\n  background-position: center;\n  background-size: auto 18px;\n  background-repeat: no-repeat;\n  border: 0;\n  margin: 0 -16px 0 8px;\n  outline: none;\n  cursor: pointer;\n  transition: opacity 85ms ease-out;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  &:hover {\n    background-color: #f6f6f9;\n    fill: ", ";\n  }\n"]), f.color.grey(8)),
      I = t.div(F = F || E(["\n  min-width: 192px;\n  border-radius: ", ";\n  border: 1px solid #efefef;\n  display: block;\n  position: absolute;\n  bottom: ", ";\n  right: ", ";\n  transform: translate3d(0, 0, 0) scale3d(0.5, 0.5, 1);\n  opacity: 0;\n  pointer-events: none;\n  transition: all 85ms ease-out;\n  transform-origin: 100% 100%;\n  box-shadow: ", ";\n  background-color: white;\n  overflow: hidden;\n  z-index: 100;\n  ", ";\n"], ["\n  min-width: 192px;\n  border-radius: ", ";\n  border: 1px solid #efefef;\n  display: block;\n  position: absolute;\n  bottom: ", ";\n  right: ", ";\n  transform: translate3d(0, 0, 0) scale3d(0.5, 0.5, 1);\n  opacity: 0;\n  pointer-events: none;\n  transition: all 85ms ease-out;\n  transform-origin: 100% 100%;\n  box-shadow: ", ";\n  background-color: white;\n  overflow: hidden;\n  z-index: 100;\n  ", ";\n"]), f.radius(), f.padding(), f.padding(), f.shadow("big"), function (n) {
    return n.open && l.css(C = C || E(["\n      opacity: 1;\n      pointer-events: all;\n      transform: translate3d(0, -28px, 0) scale3d(1, 1, 1);\n    "], ["\n      opacity: 1;\n      pointer-events: all;\n      transform: translate3d(0, -28px, 0) scale3d(1, 1, 1);\n    "]));
  }),
      M = t.button(S = S || E(["\n  position: relative;\n  text-align: center;\n  font-size: ", ";\n  padding: 0 12px;\n  height: 40px;\n  font-weight: 500;\n  width: 100%;\n  background: none;\n  cursor: pointer;\n  outline: none;\n  border: 0;\n  transition: all 85ms ease-out;\n  &:hover {\n    color: ", ";\n    background-color: #f6f6f9;\n  }\n  &:not(:last-child) {\n    border-bottom: 1px solid #efefef;\n  }\n"], ["\n  position: relative;\n  text-align: center;\n  font-size: ", ";\n  padding: 0 12px;\n  height: 40px;\n  font-weight: 500;\n  width: 100%;\n  background: none;\n  cursor: pointer;\n  outline: none;\n  border: 0;\n  transition: all 85ms ease-out;\n  &:hover {\n    color: ", ";\n    background-color: #f6f6f9;\n  }\n  &:not(:last-child) {\n    border-bottom: 1px solid #efefef;\n  }\n"]), f.font.size(0), f.color.primary()),
      D = function D(n, e) {
    return e.id < n.id ? -1 : e.id > n.id ? 1 : 0;
  },
      T = t.li(q = q || E(["\n  position: relative;\n  font-size: ", ";\n  position: relative;\n  padding: ", ";\n  color: ", ";\n  font-weight: normal;\n  transition: color 150ms ease-out;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  user-select: none;\n  svg {\n    width: 24px;\n    fill: ", ";\n    margin-top: -1px;\n    height: auto;\n    transform: translate3d(0, 0, 0);\n    transition: transform 250ms ease-out;\n  }\n  &:after {\n    content: '';\n    display: block;\n    width: 100%;\n    background-color: ", ";\n    height: 1px;\n    position: absolute;\n    bottom: 0;\n    left: ", ";\n    transform-origin: 0 0;\n    transform: scale3d(0.15, 1, 1) translate3d(0, 0, 0);\n    transition: all 250ms ease-out;\n  }\n  &:hover {\n    color: ", ";\n    svg {\n      transform: translate3d(3px, 0, 0);\n      transition: transform 250ms ease;\n      fill: ", ";\n    }\n    &:after {\n      transform: scale3d(1, 1, 1) translate3d(-", ", 0, 0);\n    }\n  }\n"], ["\n  position: relative;\n  font-size: ", ";\n  position: relative;\n  padding: ", ";\n  color: ", ";\n  font-weight: normal;\n  transition: color 150ms ease-out;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  user-select: none;\n  svg {\n    width: 24px;\n    fill: ", ";\n    margin-top: -1px;\n    height: auto;\n    transform: translate3d(0, 0, 0);\n    transition: transform 250ms ease-out;\n  }\n  &:after {\n    content: '';\n    display: block;\n    width: 100%;\n    background-color: ", ";\n    height: 1px;\n    position: absolute;\n    bottom: 0;\n    left: ", ";\n    transform-origin: 0 0;\n    transform: scale3d(0.15, 1, 1) translate3d(0, 0, 0);\n    transition: all 250ms ease-out;\n  }\n  &:hover {\n    color: ", ";\n    svg {\n      transform: translate3d(3px, 0, 0);\n      transition: transform 250ms ease;\n      fill: ", ";\n    }\n    &:after {\n      transform: scale3d(1, 1, 1) translate3d(-", ", 0, 0);\n    }\n  }\n"]), f.font.size(6), f.padding(), f.color.grey(8), f.color.grey(3), f.color.grey(2), f.padding(), f.color.primary(), f.color.grey(8), f.padding()),
      B = l.keyframes(R = R || E(["\n  from {\n    transform: translate3d(-100%,0,0);\n    opacity: 0;\n  }\n\n  to {\n    transform: translate3d(0,0,0);\n    opacity: 1;\n  }\n"], ["\n  from {\n    transform: translate3d(-100%,0,0);\n    opacity: 0;\n  }\n\n  to {\n    transform: translate3d(0,0,0);\n    opacity: 1;\n  }\n"]));

  function A(n) {
    var e = n.children,
        t = p.useState(null),
        r = t[0],
        o = t[1],
        i = p.useCallback(function (n) {
      null !== n && o(n);
    }, []);
    return p.createElement(p.Fragment, null, p.createElement("div", {
      id: "modal-root",
      ref: i
    }), p.createElement(U.Provider, {
      value: {
        portalNode: r
      }
    }, e));
  }

  var q,
      R,
      _,
      N,
      G,
      L,
      H = t.ul(_ = _ || E(["\n  padding: ", ";\n  cursor: pointer;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  overflow-y: auto;\n  ", " {\n    animation: ", " 150ms ease-out both 1;\n    ", "\n  }\n"], ["\n  padding: ", ";\n  cursor: pointer;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  overflow-y: auto;\n  ", " {\n    animation: ", " 150ms ease-out both 1;\n    ", "\n  }\n"]), f.padding(), T, B, function () {
    for (var n, e = "", t = 0; t < 15; t += 1) {
      e += "\n    &:nth-child(" + ((n = t) + 1) + ") {\n      animation-delay: " + 25 * n + "ms;\n    }\n  ";
    }

    return e;
  }()),
      Y = function Y(n) {
    var e = n.dotSize,
        t = void 0 === e ? 8 : e,
        r = n.color,
        o = void 0 === r ? "white" : r;
    return p.createElement("div", null, p.createElement(W, {
      dotSize: t,
      color: o
    }), p.createElement(W, {
      dotSize: t,
      color: o
    }), p.createElement(W, {
      dotSize: t,
      color: o
    }));
  },
      K = l.keyframes(N = N || E(["\n  0% { transform: scale(0.1); }\n  50% { transform: scale(1); }\n  90% { transform: scale(0.1); }\n  100% { transform: scale(0.1); }\n"], ["\n  0% { transform: scale(0.1); }\n  50% { transform: scale(1); }\n  90% { transform: scale(0.1); }\n  100% { transform: scale(0.1); }\n"])),
      W = t.span(L = L || E(["\n  animation: ", " 2s linear infinite;\n  display: inline-block;\n  margin-right: 4px;\n  :nth-child(2) {\n    animation-delay: 0.3s;\n  }\n  :nth-child(3) {\n    animation-delay: 0.5s;\n  }\n  ", "\n"], ["\n  animation: ", " 2s linear infinite;\n  display: inline-block;\n  margin-right: 4px;\n  :nth-child(2) {\n    animation-delay: 0.3s;\n  }\n  :nth-child(3) {\n    animation-delay: 0.5s;\n  }\n  ", "\n"]), K, function (n) {
    var e = n.color,
        t = n.dotSize;
    return l.css(G = G || E(["\n      background: ", ";\n      width: ", "px;\n      height: ", "px;\n      border-radius: ", "px;\n    "], ["\n      background: ", ";\n      width: ", "px;\n      height: ", "px;\n      border-radius: ", "px;\n    "]), e, t, t, t);
  }),
      V = 340,
      U = p.createContext(null);

  function J() {
    var n = p.useContext(U);
    if (!n) throw new Error("No Modal Container context provided");
    return n;
  }

  function Q(n) {
    var e = w(n, []),
        t = J().portalNode;
    return t && t ? r.createPortal(p.createElement(f.TinaReset, null, p.createElement(sn, null, p.createElement("div", _v({}, e)))), t) : null;
  }

  function X(n) {
    var e = n.tinaForm,
        t = n.field,
        r = p.useState(!1),
        o = r[0],
        i = r[1];
    return p.createElement(p.Fragment, null, p.createElement(yn, {
      onClick: function onClick() {
        return i(function (n) {
          return !n;
        });
      }
    }, wn(t), p.createElement(u.RightArrowIcon, null)), p.createElement(vn, {
      isExpanded: o,
      setExpanded: i,
      field: t,
      tinaForm: e
    }));
  }

  var Z,
      $,
      nn,
      en,
      tn,
      rn,
      on,
      an,
      ln,
      sn = t.div(Z = Z || E(["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.5);\n  overflow: auto;\n  padding: 0;\n  z-index: ", ";\n"], ["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.5);\n  overflow: auto;\n  padding: 0;\n  z-index: ", ";\n"]), 2147000100),
      dn = t.h2($ = $ || E(["\n  font-size: ", ";\n  font-weight: 500;\n  line-height: normal;\n  margin: 0;\n"], ["\n  font-size: ", ";\n  font-weight: 500;\n  line-height: normal;\n  margin: 0;\n"]), f.font.size(5)),
      cn = t.div(nn = nn || E(["\n  display: flex;\n  align-items: center;\n  fill: ", ";\n  cursor: pointer;\n  transition: fill 85ms ease-out;\n  svg {\n    width: 24px;\n    height: auto;\n  }\n  &:hover {\n    fill: ", ";\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  fill: ", ";\n  cursor: pointer;\n  transition: fill 85ms ease-out;\n  svg {\n    width: 24px;\n    height: auto;\n  }\n  &:hover {\n    fill: ", ";\n  }\n"]), f.color.grey(5), f.color.grey(8)),
      pn = t(function (n) {
    var e = n.children,
        t = n.close,
        r = w(n, ["children", "close"]);
    return p.createElement("div", _v({}, r), p.createElement(dn, null, e), p.createElement(cn, {
      onClick: t
    }, p.createElement(u.CloseIcon, null)));
  })(en = en || E(["\n  height: 56px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 ", " 0 ", ";\n  border-bottom: 1px solid ", ";\n  margin: 0;\n"], ["\n  height: 56px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 ", " 0 ", ";\n  border-bottom: 1px solid ", ";\n  margin: 0;\n"]), f.padding(), f.padding(), f.color.grey(3)),
      un = t.div(tn = tn || E(["\n  padding: ", ";\n  margin: 0;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  min-height: 160px;\n\n  &:last-child {\n    border-radius: 0 0 5px 5px;\n  }\n"], ["\n  padding: ", ";\n  margin: 0;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  min-height: 160px;\n\n  &:last-child {\n    border-radius: 0 0 5px 5px;\n  }\n"]), function (n) {
    return n.padded ? f.padding() : "0";
  }),
      fn = t.div(rn = rn || E(["\n  display: flex;\n  justify-content: flex-end;\n  border-radius: 0 0 5px 5px;\n  padding: 0 ", " ", " ", ";\n  ", " {\n    flex: 0 1 auto;\n    min-width: 128px;\n    margin: 0 ", " 0 0;\n    &:last-child {\n      margin-right: 0;\n    }\n  }\n"], ["\n  display: flex;\n  justify-content: flex-end;\n  border-radius: 0 0 5px 5px;\n  padding: 0 ", " ", " ", ";\n  ", " {\n    flex: 0 1 auto;\n    min-width: 128px;\n    margin: 0 ", " 0 0;\n    &:last-child {\n      margin-right: 0;\n    }\n  }\n"]), f.padding(), f.padding(), f.padding(), f.Button, f.padding("small")),
      mn = l.keyframes(on = on || E(["\n  0% {\n    transform: translate3d( 0, -2rem, 0 );\n    opacity: 0;\n  }\n\n  100% {\n    transform: translate3d( 0, 0, 0 );\n    opacity: 1;\n  }\n"], ["\n  0% {\n    transform: translate3d( 0, -2rem, 0 );\n    opacity: 0;\n  }\n\n  100% {\n    transform: translate3d( 0, 0, 0 );\n    opacity: 1;\n  }\n"])),
      gn = t.div(an = an || E(['\n  display: block;\n  z-index: 1;\n  overflow: visible; /* Keep this as "visible", select component needs to overflow */\n  background-color: #f6f6f9;\n  border-radius: ', ";\n  margin: 40px auto;\n  width: 460px;\n  max-width: 90%;\n  animation: ", " 150ms ease-out 1;\n"], ['\n  display: block;\n  z-index: 1;\n  overflow: visible; /* Keep this as "visible", select component needs to overflow */\n  background-color: #f6f6f9;\n  border-radius: ', ";\n  margin: 40px auto;\n  width: 460px;\n  max-width: 90%;\n  animation: ", " 150ms ease-out 1;\n"]), f.radius("small"), mn),
      hn = function hn(n) {
    var e = n.pristine,
        t = n.reset,
        r = p.useState(!1),
        o = r[0],
        i = r[1];
    return p.createElement(p.Fragment, null, p.createElement(xn, {
      onClick: function onClick() {
        i(function (n) {
          return !n;
        });
      },
      disabled: e
    }, "Reset"), o && p.createElement(bn, {
      reset: t,
      close: function close() {
        return i(!1);
      }
    }));
  },
      bn = function bn(n) {
    var e = n.close,
        t = n.reset;
    return p.createElement(Q, null, p.createElement(gn, null, p.createElement(pn, {
      close: e
    }, "Reset"), p.createElement(un, {
      padded: !0
    }, p.createElement("p", null, "Are you sure you want to reset all changes?")), p.createElement(fn, null, p.createElement(f.Button, {
      onClick: e
    }, "Cancel"), p.createElement(f.Button, {
      margin: !0,
      primary: !0,
      onClick: function onClick() {
        return y(void 0, void 0, void 0, function () {
          return k(this, function (n) {
            switch (n.label) {
              case 0:
                return [4, t()];

              case 1:
                return n.sent(), e(), [2];
            }
          });
        });
      }
    }, "Reset"))));
  },
      xn = t(f.Button)(ln = ln || E(["\n  flex: 0 0 96px;\n"], ["\n  flex: 0 0 96px;\n"])),
      vn = function vn(n) {
    var e = n.setExpanded,
        t = n.isExpanded,
        r = n.tinaForm,
        o = n.field,
        i = p.useMemo(function () {
      return o.fields.map(function (n) {
        return _v(_v({}, n), {
          name: o.name + "." + n.name
        });
      });
    }, [o.fields, o.name]);
    return p.createElement(Cn, {
      isExpanded: t
    }, p.createElement(kn, {
      onClick: function onClick() {
        return e(!1);
      }
    }, p.createElement(u.LeftArrowIcon, null), " ", p.createElement("span", null, wn(o))), p.createElement(En, null, t ? p.createElement(c.FieldsBuilder, {
      form: r,
      fields: i
    }) : null));
  },
      wn = function wn(n) {
    return p.createElement(Pn, null, n.label || n.name);
  },
      yn = t.div(Fn = Fn || E(["\n  position: relative;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border: 1px solid ", ";\n  border-radius: ", ";\n  margin: 0 0 24px 0;\n  overflow: visible;\n  line-height: 1.35;\n  padding: 12px;\n  color: #282828;\n  background-color: white;\n\n  svg {\n    width: 24px;\n    height: auto;\n    fill: ", ";\n    transition: all 85ms ease-out;\n  }\n\n  &:hover {\n    svg {\n      fill: ", ";\n    }\n    color: #0084ff;\n  }\n"], ["\n  position: relative;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border: 1px solid ", ";\n  border-radius: ", ";\n  margin: 0 0 24px 0;\n  overflow: visible;\n  line-height: 1.35;\n  padding: 12px;\n  color: #282828;\n  background-color: white;\n\n  svg {\n    width: 24px;\n    height: auto;\n    fill: ", ";\n    transition: all 85ms ease-out;\n  }\n\n  &:hover {\n    svg {\n      fill: ", ";\n    }\n    color: #0084ff;\n  }\n"]), f.color.grey(2), f.radius("small"), f.color.grey(3), f.color.grey(8)),
      kn = t(yn)(Sn = Sn || E(["\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  flex: 0 0 auto;\n  background-color: white;\n  justify-content: flex-start;\n  border: none;\n  border-radius: 0;\n  border-bottom: 1px solid ", ";\n  margin: 0;\n  padding: 12px 20px;\n\n  span {\n    flex: 1 1 auto;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  svg {\n    flex: 0 0 auto;\n    transform: translate3d(-4px, 0, 0);\n  }\n\n  &:hover {\n    svg {\n      transform: translate3d(-7px, 0, 0);\n    }\n  }\n"], ["\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  flex: 0 0 auto;\n  background-color: white;\n  justify-content: flex-start;\n  border: none;\n  border-radius: 0;\n  border-bottom: 1px solid ", ";\n  margin: 0;\n  padding: 12px 20px;\n\n  span {\n    flex: 1 1 auto;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  svg {\n    flex: 0 0 auto;\n    transform: translate3d(-4px, 0, 0);\n  }\n\n  &:hover {\n    svg {\n      transform: translate3d(-7px, 0, 0);\n    }\n  }\n"]), f.color.grey(2)),
      En = t.div(On = On || E(["\n  background: #f6f6f9;\n  position: relative;\n  display: flex;\n  flex: 1 1 auto;\n  overflow-y: auto;\n"], ["\n  background: #f6f6f9;\n  position: relative;\n  display: flex;\n  flex: 1 1 auto;\n  overflow-y: auto;\n"])),
      Pn = t.span(jn = jn || E(["\n  margin: 0;\n  font-size: ", ";\n  font-weight: 500;\n  color: inherit;\n  transition: all 85ms ease-out;\n"], ["\n  margin: 0;\n  font-size: ", ";\n  font-weight: 500;\n  color: inherit;\n  transition: all 85ms ease-out;\n"]), f.font.size(2)),
      zn = l.keyframes(In = In || E(["\n  0% {\n    transform: translate3d( 100%, 0, 0 );\n  }\n  100% {\n    transform: translate3d( 0, 0, 0 );\n  }\n"], ["\n  0% {\n    transform: translate3d( 100%, 0, 0 );\n  }\n  100% {\n    transform: translate3d( 0, 0, 0 );\n  }\n"])),
      Cn = t.div(Tn = Tn || E(["\n  position: fixed;\n  width: ", "px;\n  top: ", "px;\n  bottom: ", "px;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  overflow: hidden;\n  z-index: 50;\n  pointer-events: ", ";\n  border-top: 1px solid ", ";\n\n  > * {\n    ", ";\n\n    ", ";\n  }\n"], ["\n  position: fixed;\n  width: ", "px;\n  top: ", "px;\n  bottom: ", "px;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  overflow: hidden;\n  z-index: 50;\n  pointer-events: ", ";\n  border-top: 1px solid ", ";\n\n  > * {\n    ", ";\n\n    ", ";\n  }\n"]), V, 60, 60, function (n) {
    return n.isExpanded ? "all" : "none";
  }, f.color.grey(2), function (n) {
    return n.isExpanded && l.css(Mn = Mn || E(["\n        animation-name: ", ";\n        animation-duration: 150ms;\n        animation-delay: 0;\n        animation-iteration-count: 1;\n        animation-timing-function: ease-out;\n        animation-fill-mode: backwards;\n      "], ["\n        animation-name: ", ";\n        animation-duration: 150ms;\n        animation-delay: 0;\n        animation-iteration-count: 1;\n        animation-timing-function: ease-out;\n        animation-fill-mode: backwards;\n      "]), zn);
  }, function (n) {
    return !n.isExpanded && l.css(Dn = Dn || E(["\n        transition: transform 150ms ease-out;\n        transform: translate3d(100%, 0, 0);\n      "], ["\n        transition: transform 150ms ease-out;\n        transform: translate3d(100%, 0, 0);\n      "]));
  });

  var Fn,
      Sn,
      On,
      jn,
      In,
      Mn,
      Dn,
      Tn,
      Bn,
      An,
      qn,
      Rn,
      _n,
      Nn,
      Gn,
      Ln,
      Hn,
      Yn,
      Kn,
      Wn,
      Vn,
      Un,
      Jn,
      Qn = {
    name: "group",
    Component: X
  },
      Xn = function Xn() {
    return p.createElement(ne, null, "There's no items");
  },
      Zn = function Zn(n) {
    var t = n.label,
        r = n.tinaForm,
        o = n.field,
        i = n.index,
        a = n.template,
        l = n.block,
        e = p.useState(!1),
        s = e[0],
        d = e[1],
        c = p.useCallback(function () {
      r.mutators.remove(o.name, i);
    }, [r, o, i]);
    return p.createElement(g.Draggable, {
      key: i,
      type: o.name,
      draggableId: o.name + "." + i,
      index: i
    }, function (n, e) {
      return p.createElement(p.Fragment, null, p.createElement(de, _v({
        ref: n.innerRef,
        isDragging: e.isDragging
      }, n.draggableProps, n.dragHandleProps), p.createElement(pe, null), p.createElement(oe, {
        onClick: function onClick() {
          return d(!0);
        }
      }, p.createElement(ie, null, t || a.label)), p.createElement(ce, {
        onClick: c
      }, p.createElement(u.TrashIcon, null))), p.createElement(ue, {
        isExpanded: s,
        setExpanded: d,
        field: o,
        item: l,
        index: i,
        tinaForm: r,
        label: t || a.label,
        template: a
      }));
    });
  },
      $n = function $n(n) {
    var e = n.tinaForm,
        t = n.field,
        r = n.index,
        o = p.useCallback(function () {
      e.mutators.remove(t.name, r);
    }, [e, t, r]);
    return p.createElement(g.Draggable, {
      key: r,
      type: t.name,
      draggableId: t.name + "." + r,
      index: r
    }, function (n, e) {
      return p.createElement(de, _v({
        ref: n.innerRef,
        isDragging: e.isDragging
      }, n.draggableProps, n.dragHandleProps), p.createElement(pe, null), p.createElement(oe, null, p.createElement(ie, {
        error: !0
      }, "Invalid Block")), p.createElement(ce, {
        onClick: o
      }, p.createElement(u.TrashIcon, null)));
    });
  },
      ne = t.div(Bn = Bn || E(["\n  text-align: center;\n  border-radius: ", ";\n  background-color: ", ";\n  color: ", ";\n  line-height: 1.35;\n  padding: 12px 0;\n  font-size: ", ";\n  font-weight: 500;\n"], ["\n  text-align: center;\n  border-radius: ", ";\n  background-color: ", ";\n  color: ", ";\n  line-height: 1.35;\n  padding: 12px 0;\n  font-size: ", ";\n  font-weight: 500;\n"]), f.radius("small"), f.color.grey(2), f.color.grey(4), f.font.size(2)),
      ee = t.div(qn = qn || E(["\n  min-width: 192px;\n  border-radius: ", ";\n  border: 1px solid #efefef;\n  display: block;\n  position: absolute;\n  top: 0;\n  right: 0;\n  transform: translate3d(0, 0, 0) scale3d(0.5, 0.5, 1);\n  opacity: 0;\n  pointer-events: none;\n  transition: all 150ms ease-out;\n  transform-origin: 100% 0;\n  box-shadow: ", ";\n  background-color: white;\n  overflow: hidden;\n  z-index: 100;\n  ", ";\n"], ["\n  min-width: 192px;\n  border-radius: ", ";\n  border: 1px solid #efefef;\n  display: block;\n  position: absolute;\n  top: 0;\n  right: 0;\n  transform: translate3d(0, 0, 0) scale3d(0.5, 0.5, 1);\n  opacity: 0;\n  pointer-events: none;\n  transition: all 150ms ease-out;\n  transform-origin: 100% 0;\n  box-shadow: ", ";\n  background-color: white;\n  overflow: hidden;\n  z-index: 100;\n  ", ";\n"]), f.radius(), f.shadow("big"), function (n) {
    return n.open && l.css(An = An || E(["\n      opacity: 1;\n      pointer-events: all;\n      transform: translate3d(0, 36px, 0) scale3d(1, 1, 1);\n    "], ["\n      opacity: 1;\n      pointer-events: all;\n      transform: translate3d(0, 36px, 0) scale3d(1, 1, 1);\n    "]));
  }),
      te = t.div(Rn = Rn || E(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])),
      re = t.button(_n = _n || E(["\n  position: relative;\n  text-align: center;\n  font-size: ", ";\n  padding: ", ";\n  font-weight: 500;\n  width: 100%;\n  background: none;\n  cursor: pointer;\n  outline: none;\n  border: 0;\n  transition: all 85ms ease-out;\n  &:hover {\n    color: ", ";\n    background-color: #f6f6f9;\n  }\n  &:not(:last-child) {\n    border-bottom: 1px solid #efefef;\n  }\n"], ["\n  position: relative;\n  text-align: center;\n  font-size: ", ";\n  padding: ", ";\n  font-weight: 500;\n  width: 100%;\n  background: none;\n  cursor: pointer;\n  outline: none;\n  border: 0;\n  transition: all 85ms ease-out;\n  &:hover {\n    color: ", ";\n    background-color: #f6f6f9;\n  }\n  &:not(:last-child) {\n    border-bottom: 1px solid #efefef;\n  }\n"]), f.font.size(0), f.padding("small"), f.color.primary()),
      oe = t.div(Nn = Nn || E(["\n  flex: 1 1 0;\n  min-width: 0;\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px;\n"], ["\n  flex: 1 1 0;\n  min-width: 0;\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px;\n"])),
      ie = t.span(Ln = Ln || E(["\n  margin: 0;\n  font-size: ", ";\n  font-weight: 500;\n  flex: 1 1 auto;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: inherit;\n  transition: all 85ms ease-out;\n  text-align: left;\n\n  ", ";\n"], ["\n  margin: 0;\n  font-size: ", ";\n  font-weight: 500;\n  flex: 1 1 auto;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: inherit;\n  transition: all 85ms ease-out;\n  text-align: left;\n\n  ", ";\n"]), f.font.size(2), function (n) {
    return n.error && l.css(Gn = Gn || E(["\n      color: ", " !important;\n    "], ["\n      color: ", " !important;\n    "]), f.color.error());
  }),
      ae = t.div(Hn = Hn || E(["\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n  position: relative;\n  ", " {\n    font-size: ", ";\n  }\n"], ["\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n  position: relative;\n  ", " {\n    font-size: ", ";\n  }\n"]), ie, f.font.size(3)),
      le = t.div(Yn = Yn || E(["\n  max-height: initial;\n  position: relative;\n  height: auto;\n  margin-bottom: 24px;\n  border-radius: ", ";\n  background-color: ", ";\n"], ["\n  max-height: initial;\n  position: relative;\n  height: auto;\n  margin-bottom: 24px;\n  border-radius: ", ";\n  background-color: ", ";\n"]), f.radius("small"), f.color.grey(2)),
      se = t.div(Kn = Kn || E([""], [""])),
      de = t.div(Vn = Vn || E(["\n  position: relative;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: stretch;\n  background-color: white;\n  border: 1px solid ", ";\n  margin: 0 0 -1px 0;\n  overflow: visible;\n  line-height: 1.35;\n  padding: 0;\n  font-size: ", ";\n  font-weight: 500;\n\n  ", " {\n    color: #282828;\n    align-self: center;\n    max-width: 100%;\n  }\n\n  svg {\n    fill: ", ";\n    width: 20px;\n    height: auto;\n    transition: fill 85ms ease-out;\n  }\n\n  &:hover {\n    svg {\n      fill: ", ";\n    }\n    ", " {\n      color: #0084ff;\n    }\n  }\n\n  &:first-child {\n    border-radius: 4px 4px 0 0;\n  }\n\n  &:nth-last-child(2) {\n    border-radius: 0 0 4px 4px;\n    &:first-child {\n      border-radius: ", ";\n    }\n  }\n\n  ", ";\n"], ["\n  position: relative;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: stretch;\n  background-color: white;\n  border: 1px solid ", ";\n  margin: 0 0 -1px 0;\n  overflow: visible;\n  line-height: 1.35;\n  padding: 0;\n  font-size: ", ";\n  font-weight: 500;\n\n  ", " {\n    color: #282828;\n    align-self: center;\n    max-width: 100%;\n  }\n\n  svg {\n    fill: ", ";\n    width: 20px;\n    height: auto;\n    transition: fill 85ms ease-out;\n  }\n\n  &:hover {\n    svg {\n      fill: ", ";\n    }\n    ", " {\n      color: #0084ff;\n    }\n  }\n\n  &:first-child {\n    border-radius: 4px 4px 0 0;\n  }\n\n  &:nth-last-child(2) {\n    border-radius: 0 0 4px 4px;\n    &:first-child {\n      border-radius: ", ";\n    }\n  }\n\n  ", ";\n"]), f.color.grey(2), f.font.size(2), ie, f.color.grey(3), f.color.grey(8), ie, f.radius("small"), function (n) {
    return n.isDragging && l.css(Wn = Wn || E(["\n      border-radius: ", ";\n      box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.12);\n\n      svg {\n        fill: ", ";\n      }\n      ", " {\n        color: #0084ff;\n      }\n\n      ", " {\n        svg:first-child {\n          opacity: 0;\n        }\n        svg:last-child {\n          opacity: 1;\n        }\n      }\n    "], ["\n      border-radius: ", ";\n      box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.12);\n\n      svg {\n        fill: ", ";\n      }\n      ", " {\n        color: #0084ff;\n      }\n\n      ", " {\n        svg:first-child {\n          opacity: 0;\n        }\n        svg:last-child {\n          opacity: 1;\n        }\n      }\n    "]), f.radius("small"), f.color.grey(8), ie, pe);
  }),
      ce = t.button(Un = Un || E(["\n  text-align: center;\n  flex: 0 0 auto;\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n  padding: 12px 8px;\n  margin: 0;\n  transition: all 85ms ease-out;\n  &:hover {\n    background-color: #f6f6f9;\n  }\n"], ["\n  text-align: center;\n  flex: 0 0 auto;\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n  padding: 12px 8px;\n  margin: 0;\n  transition: all 85ms ease-out;\n  &:hover {\n    background-color: #f6f6f9;\n  }\n"])),
      pe = t(function (n) {
    var e = w(n, []);
    return p.createElement("div", _v({}, e), p.createElement(u.DragIcon, null), p.createElement(u.ReorderIcon, null));
  })(Jn = Jn || E(["\n  margin: 0;\n  flex: 0 0 auto;\n  width: 32px;\n  position: relative;\n  fill: inherit;\n  padding: 12px 0;\n  transition: all 85ms ease-out;\n  &:hover {\n    background-color: #f6f6f9;\n    cursor: grab;\n  }\n  svg {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    width: 20px;\n    height: 20px;\n    transform: translate3d(-50%, -50%, 0);\n    transition: all 85ms ease-out;\n  }\n  svg:last-child {\n    opacity: 0;\n  }\n  *:hover > & {\n    svg:first-child {\n      opacity: 0;\n    }\n    svg:last-child {\n      opacity: 1;\n    }\n  }\n"], ["\n  margin: 0;\n  flex: 0 0 auto;\n  width: 32px;\n  position: relative;\n  fill: inherit;\n  padding: 12px 0;\n  transition: all 85ms ease-out;\n  &:hover {\n    background-color: #f6f6f9;\n    cursor: grab;\n  }\n  svg {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    width: 20px;\n    height: 20px;\n    transform: translate3d(-50%, -50%, 0);\n    transition: all 85ms ease-out;\n  }\n  svg:last-child {\n    opacity: 0;\n  }\n  *:hover > & {\n    svg:first-child {\n      opacity: 0;\n    }\n    svg:last-child {\n      opacity: 1;\n    }\n  }\n"])),
      ue = function ue(n) {
    var e = n.setExpanded,
        t = n.isExpanded,
        r = n.tinaForm,
        o = n.field,
        i = n.index,
        a = n.label,
        l = n.template,
        s = p.useMemo(function () {
      return l.fields.map(function (n) {
        return _v(_v({}, n), {
          name: o.name + "." + i + "." + n.name
        });
      });
    }, [o.name, i, l.fields]);
    return p.createElement(Cn, {
      isExpanded: t
    }, p.createElement(kn, {
      onClick: function onClick() {
        return e(!1);
      }
    }, p.createElement(u.LeftArrowIcon, null), p.createElement(ie, null, a)), p.createElement(En, null, t ? p.createElement(c.FieldsBuilder, {
      form: r,
      fields: s
    }) : null));
  },
      fe = {
    name: "blocks",
    Component: function Component(n) {
      var o = n.tinaForm,
          r = n.form,
          i = n.field,
          e = n.input,
          a = p.useCallback(function (n, e) {
        var t = {};
        (t = "function" == typeof e.defaultItem ? e.defaultItem() : e.defaultItem || {})._template = n, r.mutators.insert(i.name, 0, t);
      }, [i.name, r.mutators]),
          t = e.value || [],
          l = p.useState(!1),
          s = l[0],
          d = l[1];
      return p.createElement(p.Fragment, null, p.createElement(ae, null, p.createElement(ie, null, i.label || i.name), p.createElement(f.IconButton, {
        onClick: function onClick() {
          return d(!0);
        },
        open: s,
        primary: !0,
        small: !0
      }, p.createElement(u.AddIcon, null)), p.createElement(ee, {
        open: s
      }, p.createElement(m.Dismissible, {
        click: !0,
        escape: !0,
        onDismiss: function onDismiss() {
          return d(!1);
        },
        disabled: !s
      }, p.createElement(te, null, Object.entries(i.templates).map(function (n) {
        var e = n[0],
            t = n[1];
        return p.createElement(re, {
          onClick: function onClick() {
            a(e, t), d(!1);
          }
        }, t.label);
      }))))), p.createElement(le, null, p.createElement(se, null, p.createElement(g.Droppable, {
        droppableId: i.name,
        type: i.name
      }, function (n) {
        return p.createElement("div", {
          ref: n.innerRef,
          className: "edit-page--list-parent"
        }, 0 === t.length && p.createElement(Xn, null), t.map(function (n, e) {
          var t = i.templates[n._template];
          if (!t) return p.createElement($n, {
            index: e,
            field: i,
            tinaForm: o
          });
          var r;
          return p.createElement(Zn, _v({
            block: n,
            template: t,
            index: e,
            field: i,
            tinaForm: o
          }, (r = n, t.itemProps ? t.itemProps(r) : {})));
        }), n.placeholder);
      }))));
    }
  };

  function me(e) {
    return function (n) {
      return p.createElement(ge, {
        name: n.input.name,
        label: n.field.label,
        description: n.field.description,
        error: n.meta.error
      }, p.createElement(e, _v({}, n)));
    };
  }

  function ge(n) {
    return p.createElement(Be, null, p.createElement(Ae, {
      htmlFor: name
    }, n.label || n.name, n.description && p.createElement(qe, null, n.description)), n.children, n.error && p.createElement(Re, null, n.error));
  }

  function he(n) {
    return n || "";
  }

  function be() {
    var n = p.useState(),
        e = n[0],
        t = n[1],
        r = h();
    d.useSubscribable(r.forms, function () {
      1 === r.forms.all().length && t(r.forms.all()[0].id);
    });
    var o = r.forms.all(),
        i = 1 < o.length,
        a = e ? r.forms.find(e) : null,
        l = !!a;
    return o.length ? a ? p.createElement(Yt, {
      isEditing: l,
      isMultiform: i
    }, p.createElement(vt, {
      activeForm: a,
      setActiveFormId: t,
      isMultiform: i
    })) : p.createElement(P, {
      isEditing: l,
      forms: o,
      setActiveFormId: t
    }) : p.createElement(qt, null);
  }

  var xe,
      ve,
      we,
      ye,
      ke,
      Ee,
      Pe,
      ze,
      Ce,
      Fe,
      Se,
      Oe,
      je,
      Ie,
      Me,
      De,
      Te,
      Be = t.div(xe = xe || E(["\n  position: relative;\n  margin-bottom: 24px;\n"], ["\n  position: relative;\n  margin-bottom: 24px;\n"])),
      Ae = t.label(ve = ve || E(["\n  display: block;\n  font-size: ", ";\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  line-height: 1.35;\n  color: ", ";\n  margin-bottom: 8px;\n  text-overflow: ellipsis;\n  width: 100%;\n  overflow: hidden;\n"], ["\n  display: block;\n  font-size: ", ";\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  line-height: 1.35;\n  color: ", ";\n  margin-bottom: 8px;\n  text-overflow: ellipsis;\n  width: 100%;\n  overflow: hidden;\n"]), f.font.size(1), f.color.grey(8)),
      qe = t.p(we = we || E(["\n  color: ", ";\n  font-size: ", ";\n  font-style: italic;\n  font-weight: lighter;\n  padding-top: 4px;\n  white-space: normal;\n"], ["\n  color: ", ";\n  font-size: ", ";\n  font-style: italic;\n  font-weight: lighter;\n  padding-top: 4px;\n  white-space: normal;\n"]), f.color.grey(6), f.font.size(0)),
      Re = t.span(ye = ye || E(["\n  display: block;\n  color: red;\n  font-size: ", ";\n  margin-top: 8px;\n  font-weight: 500;\n"], ["\n  display: block;\n  color: red;\n  font-size: ", ";\n  margin-top: 8px;\n  font-weight: 500;\n"]), f.font.size(1)),
      _e = me(function (n) {
    var e = n.input,
        t = n.field;
    return p.createElement(o.TextField, _v({}, e, {
      placeholder: t.placeholder
    }));
  }),
      Ne = {
    name: "text",
    Component: _e,
    validate: function validate(n, e, t, r) {
      if (r.required && !n) return "Required";
    },
    parse: he
  },
      Ge = "rgb(200, 200, 200)",
      Le = "rgb(40, 40, 40)",
      He = me(t(o.Wysiwyg)(ke = ke || E(["\n  position: relative;\n\n  > [contenteditable] {\n    ", "\n    overflow: auto;\n    -webkit-overflow-scrolling: touch;\n    min-height: 200px;\n    max-height: 500px;\n    overflow-y: auto;\n\n    ::selection {\n      background-color: rgba(0, 132, 255, 0.3);\n    }\n\n    div::selection {\n      background: rgba(0, 0, 0, 0);\n    }\n\n    div[contenteditable] {\n      display: inline-block;\n    }\n\n    > *:first-child {\n      margin-top: 0;\n    }\n\n    > *:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  color: ", ";\n  background-color: #fff;\n  font-size: 16px;\n  line-height: 26px;\n  white-space: pre-wrap;\n  -webkit-font-smoothing: antialiased;\n  text-shadow: none;\n  font-weight: 400;\n  cursor: auto;\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n\n  p {\n    font-size: 16px;\n    line-height: 26px;\n    font-weight: normal;\n  }\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    font-weight: 600;\n    text-transform: none;\n    padding: 0;\n    margin-bottom: 16px;\n  }\n\n  h1 {\n    font-size: 40px;\n    line-height: 48px;\n    margin-top: 0;\n    &:not(:first-child) {\n      margin-top: 32px;\n    }\n  }\n\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    &:not(:first-child) {\n      margin-top: 21px;\n    }\n  }\n\n  h2 {\n    font-size: 34px;\n    line-height: 38px;\n    margin-top: 0;\n  }\n\n  h3 {\n    font-size: 26px;\n    line-height: 30px;\n    margin-top: 0;\n  }\n\n  h4 {\n    font-size: 21px;\n    line-height: 28px;\n    margin-top: 0;\n  }\n\n  h5 {\n    font-size: 18px;\n    line-height: 24px;\n    margin-top: 0;\n  }\n\n  h6 {\n    font-size: 16px;\n    line-height: 20px;\n    margin-top: 0;\n  }\n\n  a {\n    color: #0084ff;\n    border: 0;\n    font-weight: normal;\n    text-decoration: underline;\n  }\n\n  small {\n    font-size: 0.707em;\n  }\n\n  ul,\n  ol {\n    margin: 0;\n    padding: 0;\n  }\n\n  ol li {\n    /* prevent 2-digits numbers from being cut-off */\n    margin-left: 5px;\n    margin-right: 5px;\n  }\n\n  ul {\n    margin-left: 1.5em;\n    margin-bottom: 16px;\n    list-style-type: disc;\n    list-style-position: outside;\n    list-style-image: none;\n  }\n\n  ol {\n    margin-left: 1.25em;\n    margin-bottom: 16px;\n    list-style-type: decimal;\n  }\n\n  li {\n    list-style: inherit;\n    ol,\n    ul {\n      margin-bottom: 0;\n    }\n  }\n\n  code {\n    font-family: 'Roboto Mono', monospace;\n    font-size: 14px;\n    background: rgba(53, 50, 50, 0.08);\n    padding: 0.1em 0.25em;\n  }\n\n  pre {\n    padding: 0;\n    margin: 0;\n  }\n\n  pre > code {\n    display: block;\n    padding: 0.15em 0.6em;\n  }\n\n  img {\n    max-width: 100%;\n    border: 0;\n    padding: 0;\n    margin-bottom: 16px;\n  }\n\n  hr {\n    display: block;\n    height: 1px;\n    width: 100%;\n    border: 0;\n    background: ", ";\n    margin: 16px 0;\n  }\n\n  blockquote {\n    margin: 0 0 16px 0;\n    border-left: 2px solid ", ";\n    padding-left: 15px;\n  }\n\n  mark {\n    color: ", ";\n    background-color: #ffe9a8;\n    padding: 0.1em 0.25em;\n  }\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    position: relative;\n    &:before {\n      font-size: 14px;\n      text-align: left;\n      font-weight: 500;\n      color: ", ";\n      position: absolute;\n      left: -35px;\n      width: 30px;\n      cursor: pointer;\n      transition: color 0.25s ease;\n    }\n    &:hover:before {\n      color: ", ";\n    }\n  }\n\n  blockquote {\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6 {\n      &:before {\n        display: none;\n      }\n    }\n  }\n"], ["\n  position: relative;\n\n  > [contenteditable] {\n    ", "\n    overflow: auto;\n    -webkit-overflow-scrolling: touch;\n    min-height: 200px;\n    max-height: 500px;\n    overflow-y: auto;\n\n    ::selection {\n      background-color: rgba(0, 132, 255, 0.3);\n    }\n\n    div::selection {\n      background: rgba(0, 0, 0, 0);\n    }\n\n    div[contenteditable] {\n      display: inline-block;\n    }\n\n    > *:first-child {\n      margin-top: 0;\n    }\n\n    > *:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  color: ", ";\n  background-color: #fff;\n  font-size: 16px;\n  line-height: 26px;\n  white-space: pre-wrap;\n  -webkit-font-smoothing: antialiased;\n  text-shadow: none;\n  font-weight: 400;\n  cursor: auto;\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n\n  p {\n    font-size: 16px;\n    line-height: 26px;\n    font-weight: normal;\n  }\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    font-weight: 600;\n    text-transform: none;\n    padding: 0;\n    margin-bottom: 16px;\n  }\n\n  h1 {\n    font-size: 40px;\n    line-height: 48px;\n    margin-top: 0;\n    &:not(:first-child) {\n      margin-top: 32px;\n    }\n  }\n\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    &:not(:first-child) {\n      margin-top: 21px;\n    }\n  }\n\n  h2 {\n    font-size: 34px;\n    line-height: 38px;\n    margin-top: 0;\n  }\n\n  h3 {\n    font-size: 26px;\n    line-height: 30px;\n    margin-top: 0;\n  }\n\n  h4 {\n    font-size: 21px;\n    line-height: 28px;\n    margin-top: 0;\n  }\n\n  h5 {\n    font-size: 18px;\n    line-height: 24px;\n    margin-top: 0;\n  }\n\n  h6 {\n    font-size: 16px;\n    line-height: 20px;\n    margin-top: 0;\n  }\n\n  a {\n    color: #0084ff;\n    border: 0;\n    font-weight: normal;\n    text-decoration: underline;\n  }\n\n  small {\n    font-size: 0.707em;\n  }\n\n  ul,\n  ol {\n    margin: 0;\n    padding: 0;\n  }\n\n  ol li {\n    /* prevent 2-digits numbers from being cut-off */\n    margin-left: 5px;\n    margin-right: 5px;\n  }\n\n  ul {\n    margin-left: 1.5em;\n    margin-bottom: 16px;\n    list-style-type: disc;\n    list-style-position: outside;\n    list-style-image: none;\n  }\n\n  ol {\n    margin-left: 1.25em;\n    margin-bottom: 16px;\n    list-style-type: decimal;\n  }\n\n  li {\n    list-style: inherit;\n    ol,\n    ul {\n      margin-bottom: 0;\n    }\n  }\n\n  code {\n    font-family: 'Roboto Mono', monospace;\n    font-size: 14px;\n    background: rgba(53, 50, 50, 0.08);\n    padding: 0.1em 0.25em;\n  }\n\n  pre {\n    padding: 0;\n    margin: 0;\n  }\n\n  pre > code {\n    display: block;\n    padding: 0.15em 0.6em;\n  }\n\n  img {\n    max-width: 100%;\n    border: 0;\n    padding: 0;\n    margin-bottom: 16px;\n  }\n\n  hr {\n    display: block;\n    height: 1px;\n    width: 100%;\n    border: 0;\n    background: ", ";\n    margin: 16px 0;\n  }\n\n  blockquote {\n    margin: 0 0 16px 0;\n    border-left: 2px solid ", ";\n    padding-left: 15px;\n  }\n\n  mark {\n    color: ", ";\n    background-color: #ffe9a8;\n    padding: 0.1em 0.25em;\n  }\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    position: relative;\n    &:before {\n      font-size: 14px;\n      text-align: left;\n      font-weight: 500;\n      color: ", ";\n      position: absolute;\n      left: -35px;\n      width: 30px;\n      cursor: pointer;\n      transition: color 0.25s ease;\n    }\n    &:hover:before {\n      color: ", ";\n    }\n  }\n\n  blockquote {\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6 {\n      &:before {\n        display: none;\n      }\n    }\n  }\n"]), o.InputCss, Le, Ge, Ge, Le, Ge, Le)),
      Ye = {
    name: "markdown",
    Component: He,
    parse: he
  },
      Ke = me(function (n) {
    var e = n.input;
    return p.createElement(o.TextArea, _v({}, e));
  }),
      We = {
    name: "textarea",
    Component: Ke,
    parse: he
  },
      Ve = me(function (n) {
    var e = n.input,
        t = n.field;
    return p.createElement(o.NumberInput, _v({}, e, {
      step: t.step
    }));
  }),
      Ue = {
    name: "number",
    Component: Ve,
    parse: function parse(n) {
      return n && +n;
    }
  },
      Je = me(function (n) {
    var e = n.input,
        t = n.field;
    return p.createElement(o.ColorPicker, {
      colorFormat: t.colorFormat,
      userColors: t.colors,
      widget: t.widget,
      input: e
    });
  }),
      Qe = {
    name: "color",
    Component: Je,
    parse: he
  },
      Xe = me(o.Toggle),
      Ze = {
    name: "toggle",
    type: "checkbox",
    Component: Xe
  },
      $e = me(o.Select),
      nt = {
    name: "select",
    type: "select",
    Component: $e,
    parse: he
  },
      et = t.div(Ee = Ee || E(["\n  .rdt {\n    position: relative;\n  }\n  .rdtPicker {\n    display: none;\n    position: absolute;\n    width: 250px;\n    padding: 4px;\n    margin-top: 1px;\n    z-index: 99999 !important;\n    background: #fff;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n    border: 1px solid #f9f9f9;\n  }\n  .rdtOpen .rdtPicker {\n    display: block;\n  }\n  .rdtStatic .rdtPicker {\n    box-shadow: none;\n    position: static;\n  }\n  .rdtPicker .rdtTimeToggle {\n    text-align: center;\n  }\n  .rdtPicker table {\n    width: 100%;\n    margin: 0;\n  }\n  .rdtPicker td,\n  .rdtPicker th {\n    text-align: center;\n    height: 28px;\n  }\n  .rdtPicker td {\n    cursor: pointer;\n  }\n  .rdtPicker td.rdtDay:hover,\n  .rdtPicker td.rdtHour:hover,\n  .rdtPicker td.rdtMinute:hover,\n  .rdtPicker td.rdtSecond:hover,\n  .rdtPicker .rdtTimeToggle:hover {\n    background: #eeeeee;\n    cursor: pointer;\n  }\n  .rdtPicker td.rdtOld,\n  .rdtPicker td.rdtNew {\n    color: #999999;\n  }\n  .rdtPicker td.rdtToday {\n    position: relative;\n  }\n  .rdtPicker td.rdtToday:before {\n    content: '';\n    display: inline-block;\n    border-left: 7px solid transparent;\n    border-bottom: 7px solid #428bca;\n    border-top-color: rgba(0, 0, 0, 0.2);\n    position: absolute;\n    bottom: 4px;\n    right: 4px;\n  }\n  .rdtPicker td.rdtActive,\n  .rdtPicker td.rdtActive:hover {\n    background-color: #428bca;\n    color: #fff;\n    text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);\n  }\n  .rdtPicker td.rdtActive.rdtToday:before {\n    border-bottom-color: #fff;\n  }\n  .rdtPicker td.rdtDisabled,\n  .rdtPicker td.rdtDisabled:hover {\n    background: none;\n    color: #999999;\n    cursor: not-allowed;\n  }\n  .rdtPicker td span.rdtOld {\n    color: #999999;\n  }\n  .rdtPicker td span.rdtDisabled,\n  .rdtPicker td span.rdtDisabled:hover {\n    background: none;\n    color: #999999;\n    cursor: not-allowed;\n  }\n  .rdtPicker th {\n    border-bottom: 1px solid #f9f9f9;\n  }\n  .rdtPicker .dow {\n    width: 14.2857%;\n    border-bottom: none;\n    cursor: default;\n  }\n  .rdtPicker th.rdtSwitch {\n    width: 100px;\n  }\n  .rdtPicker th.rdtNext,\n  .rdtPicker th.rdtPrev {\n    font-size: 21px;\n    vertical-align: top;\n  }\n  .rdtPrev span,\n  .rdtNext span {\n    display: block;\n    -webkit-touch-callout: none; /* iOS Safari */\n    -webkit-user-select: none; /* Chrome/Safari/Opera */\n    -khtml-user-select: none; /* Konqueror */\n    -moz-user-select: none; /* Firefox */\n    -ms-user-select: none; /* Internet Explorer/Edge */\n    user-select: none;\n  }\n  .rdtPicker th.rdtDisabled,\n  .rdtPicker th.rdtDisabled:hover {\n    background: none;\n    color: #999999;\n    cursor: not-allowed;\n  }\n  .rdtPicker thead tr:first-child th {\n    cursor: pointer;\n  }\n  .rdtPicker thead tr:first-child th:hover {\n    background: #eeeeee;\n  }\n  .rdtPicker tfoot {\n    border-top: 1px solid #f9f9f9;\n  }\n  .rdtPicker button {\n    border: none;\n    background: none;\n    cursor: pointer;\n  }\n  .rdtPicker button:hover {\n    background-color: #eee;\n  }\n  .rdtPicker thead button {\n    width: 100%;\n    height: 100%;\n  }\n  td.rdtMonth,\n  td.rdtYear {\n    height: 50px;\n    width: 25%;\n    cursor: pointer;\n  }\n  td.rdtMonth:hover,\n  td.rdtYear:hover {\n    background: #eee;\n  }\n  .rdtCounters {\n    display: inline-block;\n  }\n  .rdtCounters > div {\n    float: left;\n  }\n  .rdtCounter {\n    height: 100px;\n  }\n  .rdtCounter {\n    width: 40px;\n  }\n  .rdtCounterSeparator {\n    line-height: 100px;\n  }\n  .rdtCounter .rdtBtn {\n    height: 40%;\n    line-height: 40px;\n    cursor: pointer;\n    display: block;\n    -webkit-touch-callout: none; /* iOS Safari */\n    -webkit-user-select: none; /* Chrome/Safari/Opera */\n    -khtml-user-select: none; /* Konqueror */\n    -moz-user-select: none; /* Firefox */\n    -ms-user-select: none; /* Internet Explorer/Edge */\n    user-select: none;\n  }\n  .rdtCounter .rdtBtn:hover {\n    background: #eee;\n  }\n  .rdtCounter .rdtCount {\n    height: 20%;\n    font-size: 1.2em;\n  }\n  .rdtMilli {\n    vertical-align: middle;\n    padding-left: 8px;\n    width: 48px;\n  }\n  .rdtMilli input {\n    width: 100%;\n    font-size: 1.2em;\n    margin-top: 37px;\n  }\n  .rdtTime td {\n    cursor: default;\n  }\n"], ["\n  .rdt {\n    position: relative;\n  }\n  .rdtPicker {\n    display: none;\n    position: absolute;\n    width: 250px;\n    padding: 4px;\n    margin-top: 1px;\n    z-index: 99999 !important;\n    background: #fff;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n    border: 1px solid #f9f9f9;\n  }\n  .rdtOpen .rdtPicker {\n    display: block;\n  }\n  .rdtStatic .rdtPicker {\n    box-shadow: none;\n    position: static;\n  }\n  .rdtPicker .rdtTimeToggle {\n    text-align: center;\n  }\n  .rdtPicker table {\n    width: 100%;\n    margin: 0;\n  }\n  .rdtPicker td,\n  .rdtPicker th {\n    text-align: center;\n    height: 28px;\n  }\n  .rdtPicker td {\n    cursor: pointer;\n  }\n  .rdtPicker td.rdtDay:hover,\n  .rdtPicker td.rdtHour:hover,\n  .rdtPicker td.rdtMinute:hover,\n  .rdtPicker td.rdtSecond:hover,\n  .rdtPicker .rdtTimeToggle:hover {\n    background: #eeeeee;\n    cursor: pointer;\n  }\n  .rdtPicker td.rdtOld,\n  .rdtPicker td.rdtNew {\n    color: #999999;\n  }\n  .rdtPicker td.rdtToday {\n    position: relative;\n  }\n  .rdtPicker td.rdtToday:before {\n    content: '';\n    display: inline-block;\n    border-left: 7px solid transparent;\n    border-bottom: 7px solid #428bca;\n    border-top-color: rgba(0, 0, 0, 0.2);\n    position: absolute;\n    bottom: 4px;\n    right: 4px;\n  }\n  .rdtPicker td.rdtActive,\n  .rdtPicker td.rdtActive:hover {\n    background-color: #428bca;\n    color: #fff;\n    text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);\n  }\n  .rdtPicker td.rdtActive.rdtToday:before {\n    border-bottom-color: #fff;\n  }\n  .rdtPicker td.rdtDisabled,\n  .rdtPicker td.rdtDisabled:hover {\n    background: none;\n    color: #999999;\n    cursor: not-allowed;\n  }\n  .rdtPicker td span.rdtOld {\n    color: #999999;\n  }\n  .rdtPicker td span.rdtDisabled,\n  .rdtPicker td span.rdtDisabled:hover {\n    background: none;\n    color: #999999;\n    cursor: not-allowed;\n  }\n  .rdtPicker th {\n    border-bottom: 1px solid #f9f9f9;\n  }\n  .rdtPicker .dow {\n    width: 14.2857%;\n    border-bottom: none;\n    cursor: default;\n  }\n  .rdtPicker th.rdtSwitch {\n    width: 100px;\n  }\n  .rdtPicker th.rdtNext,\n  .rdtPicker th.rdtPrev {\n    font-size: 21px;\n    vertical-align: top;\n  }\n  .rdtPrev span,\n  .rdtNext span {\n    display: block;\n    -webkit-touch-callout: none; /* iOS Safari */\n    -webkit-user-select: none; /* Chrome/Safari/Opera */\n    -khtml-user-select: none; /* Konqueror */\n    -moz-user-select: none; /* Firefox */\n    -ms-user-select: none; /* Internet Explorer/Edge */\n    user-select: none;\n  }\n  .rdtPicker th.rdtDisabled,\n  .rdtPicker th.rdtDisabled:hover {\n    background: none;\n    color: #999999;\n    cursor: not-allowed;\n  }\n  .rdtPicker thead tr:first-child th {\n    cursor: pointer;\n  }\n  .rdtPicker thead tr:first-child th:hover {\n    background: #eeeeee;\n  }\n  .rdtPicker tfoot {\n    border-top: 1px solid #f9f9f9;\n  }\n  .rdtPicker button {\n    border: none;\n    background: none;\n    cursor: pointer;\n  }\n  .rdtPicker button:hover {\n    background-color: #eee;\n  }\n  .rdtPicker thead button {\n    width: 100%;\n    height: 100%;\n  }\n  td.rdtMonth,\n  td.rdtYear {\n    height: 50px;\n    width: 25%;\n    cursor: pointer;\n  }\n  td.rdtMonth:hover,\n  td.rdtYear:hover {\n    background: #eee;\n  }\n  .rdtCounters {\n    display: inline-block;\n  }\n  .rdtCounters > div {\n    float: left;\n  }\n  .rdtCounter {\n    height: 100px;\n  }\n  .rdtCounter {\n    width: 40px;\n  }\n  .rdtCounterSeparator {\n    line-height: 100px;\n  }\n  .rdtCounter .rdtBtn {\n    height: 40%;\n    line-height: 40px;\n    cursor: pointer;\n    display: block;\n    -webkit-touch-callout: none; /* iOS Safari */\n    -webkit-user-select: none; /* Chrome/Safari/Opera */\n    -khtml-user-select: none; /* Konqueror */\n    -moz-user-select: none; /* Firefox */\n    -ms-user-select: none; /* Internet Explorer/Edge */\n    user-select: none;\n  }\n  .rdtCounter .rdtBtn:hover {\n    background: #eee;\n  }\n  .rdtCounter .rdtCount {\n    height: 20%;\n    font-size: 1.2em;\n  }\n  .rdtMilli {\n    vertical-align: middle;\n    padding-left: 8px;\n    width: 48px;\n  }\n  .rdtMilli input {\n    width: 100%;\n    font-size: 1.2em;\n    margin-top: 37px;\n  }\n  .rdtTime td {\n    cursor: default;\n  }\n"])),
      tt = "MMM DD, YYYY",
      rt = me(function (n) {
    var e = n.input,
        t = n.field,
        r = p.useState(!1),
        o = r[0],
        i = r[1],
        a = p.useRef(null);
    return p.useEffect(function () {
      function n(n) {
        a.current && n.target && (a.current.contains(n.target) ? i(!0) : i(!1));
      }

      return document.addEventListener("mouseup", n, !1), function () {
        document.removeEventListener("mouseup", n, !1);
      };
    }, [document]), p.createElement(ot, null, p.createElement(et, {
      ref: a
    }, p.createElement(s, _v({
      value: e.value,
      onFocus: e.onFocus,
      onChange: e.onChange,
      open: o,
      timeFormat: !1,
      utc: !0
    }, t))));
  }),
      ot = t.div(Pe = Pe || E(["\n  input {\n    ", ";\n  }\n"], ["\n  input {\n    ", ";\n  }\n"]), o.InputCss),
      it = {
    name: "date",
    Component: rt,
    format: function format(n, e, t) {
      var r = "string" == typeof t.dateFormat ? t.dateFormat : tt;
      if ("string" != typeof n) return i(n).format(r);
      var o = i(n);
      return o.isValid() ? o.format(r) : n;
    },
    parse: function parse(n, e, t) {
      var r = "string" == typeof t.dateFormat ? t.dateFormat : tt;
      if ("string" != typeof n) return n.toDate();
      var o = i(n, r);
      return o.isValid() ? o.toDate() : n;
    }
  },
      at = function at() {
    return p.createElement(ut, null, "There's no items");
  },
      lt = function lt(n) {
    var t = n.tinaForm,
        r = n.field,
        o = n.index,
        e = (n.item, n.label),
        i = w(n, ["tinaForm", "field", "index", "item", "label"]),
        a = p.useState(!1),
        l = a[0],
        s = a[1],
        d = p.useCallback(function () {
      t.mutators.remove(r.name, o);
    }, [t, r, o]),
        c = e || (r.label || r.name) + " Item";
    return p.createElement(g.Draggable, {
      type: r.name,
      draggableId: r.name + "." + o,
      index: o
    }, function (n, e) {
      return p.createElement(p.Fragment, null, p.createElement(mt, _v({
        ref: n.innerRef,
        isDragging: e.isDragging
      }, n.draggableProps, n.dragHandleProps, i), p.createElement(ht, null), p.createElement(st, {
        onClick: function onClick() {
          return s(!0);
        }
      }, p.createElement(dt, null, c)), p.createElement(gt, {
        onClick: d
      }, p.createElement(u.TrashIcon, null))), p.createElement(bt, {
        isExpanded: l,
        setExpanded: s,
        field: r,
        index: o,
        tinaForm: t,
        itemTitle: c
      }));
    });
  },
      st = t.div(ze = ze || E(["\n  flex: 1 1 0;\n  min-width: 0;\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px;\n"], ["\n  flex: 1 1 0;\n  min-width: 0;\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px;\n"])),
      dt = t.span(Ce = Ce || E(["\n  margin: 0;\n  font-size: ", ";\n  font-weight: 500;\n  flex: 1 1 auto;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: inherit;\n  transition: all 85ms ease-out;\n  text-align: left;\n"], ["\n  margin: 0;\n  font-size: ", ";\n  font-weight: 500;\n  flex: 1 1 auto;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: inherit;\n  transition: all 85ms ease-out;\n  text-align: left;\n"]), f.font.size(2)),
      ct = t.div(Fe = Fe || E(["\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n  ", " {\n    font-size: ", ";\n  }\n"], ["\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n  ", " {\n    font-size: ", ";\n  }\n"]), dt, f.font.size(3)),
      pt = t.div(Se = Se || E(["\n  max-height: initial;\n  position: relative;\n  height: auto;\n  margin-bottom: 24px;\n  border-radius: ", ";\n  background-color: ", ";\n"], ["\n  max-height: initial;\n  position: relative;\n  height: auto;\n  margin-bottom: 24px;\n  border-radius: ", ";\n  background-color: ", ";\n"]), f.radius("small"), f.color.grey(2)),
      ut = t.div(Oe = Oe || E(["\n  text-align: center;\n  border-radius: ", ";\n  background-color: ", ";\n  color: ", ";\n  line-height: 1.35;\n  padding: 12px 0;\n  font-size: ", ";\n  font-weight: 500;\n"], ["\n  text-align: center;\n  border-radius: ", ";\n  background-color: ", ";\n  color: ", ";\n  line-height: 1.35;\n  padding: 12px 0;\n  font-size: ", ";\n  font-weight: 500;\n"]), f.radius("small"), f.color.grey(2), f.color.grey(4), f.font.size(2)),
      ft = t.div(je = je || E([""], [""])),
      mt = t.div(Me = Me || E(["\n  position: relative;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: stretch;\n  background-color: white;\n  border: 1px solid ", ";\n  margin: 0 0 -1px 0;\n  overflow: visible;\n  line-height: 1.35;\n  padding: 0;\n  font-size: ", ";\n  font-weight: 500;\n\n  ", " {\n    color: #282828;\n    align-self: center;\n    max-width: 100%;\n  }\n\n  svg {\n    fill: ", ";\n    width: 20px;\n    height: auto;\n    transition: fill 85ms ease-out;\n  }\n\n  &:hover {\n    svg {\n      fill: ", ";\n    }\n    ", " {\n      color: #0084ff;\n    }\n  }\n\n  &:first-child {\n    border-radius: 4px 4px 0 0;\n  }\n\n  &:nth-last-child(2) {\n    border-radius: 0 0 4px 4px;\n    &:first-child {\n      border-radius: ", ";\n    }\n  }\n\n  ", ";\n"], ["\n  position: relative;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: stretch;\n  background-color: white;\n  border: 1px solid ", ";\n  margin: 0 0 -1px 0;\n  overflow: visible;\n  line-height: 1.35;\n  padding: 0;\n  font-size: ", ";\n  font-weight: 500;\n\n  ", " {\n    color: #282828;\n    align-self: center;\n    max-width: 100%;\n  }\n\n  svg {\n    fill: ", ";\n    width: 20px;\n    height: auto;\n    transition: fill 85ms ease-out;\n  }\n\n  &:hover {\n    svg {\n      fill: ", ";\n    }\n    ", " {\n      color: #0084ff;\n    }\n  }\n\n  &:first-child {\n    border-radius: 4px 4px 0 0;\n  }\n\n  &:nth-last-child(2) {\n    border-radius: 0 0 4px 4px;\n    &:first-child {\n      border-radius: ", ";\n    }\n  }\n\n  ", ";\n"]), f.color.grey(2), f.font.size(2), dt, f.color.grey(3), f.color.grey(8), dt, f.radius("small"), function (n) {
    return n.isDragging && l.css(Ie = Ie || E(["\n      border-radius: ", ";\n      box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.12);\n\n      svg {\n        fill: ", ";\n      }\n      ", " {\n        color: #0084ff;\n      }\n\n      ", " {\n        svg:first-child {\n          opacity: 0;\n        }\n        svg:last-child {\n          opacity: 1;\n        }\n      }\n    "], ["\n      border-radius: ", ";\n      box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.12);\n\n      svg {\n        fill: ", ";\n      }\n      ", " {\n        color: #0084ff;\n      }\n\n      ", " {\n        svg:first-child {\n          opacity: 0;\n        }\n        svg:last-child {\n          opacity: 1;\n        }\n      }\n    "]), f.radius("small"), f.color.grey(8), dt, ht);
  }),
      gt = t.button(De = De || E(["\n  text-align: center;\n  flex: 0 0 auto;\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n  padding: 12px 8px;\n  margin: 0;\n  transition: all 85ms ease-out;\n  svg {\n    transition: all 85ms ease-out;\n  }\n  &:hover {\n    background-color: #f6f6f9;\n  }\n"], ["\n  text-align: center;\n  flex: 0 0 auto;\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n  padding: 12px 8px;\n  margin: 0;\n  transition: all 85ms ease-out;\n  svg {\n    transition: all 85ms ease-out;\n  }\n  &:hover {\n    background-color: #f6f6f9;\n  }\n"])),
      ht = t(function (n) {
    var e = w(n, []);
    return p.createElement("div", _v({}, e), p.createElement(u.DragIcon, null), p.createElement(u.ReorderIcon, null));
  })(Te = Te || E(["\n  margin: 0;\n  flex: 0 0 auto;\n  width: 32px;\n  position: relative;\n  fill: inherit;\n  padding: 12px 0;\n  transition: all 85ms ease-out;\n  &:hover {\n    background-color: #f6f6f9;\n    cursor: grab;\n  }\n  svg {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    width: 20px;\n    height: 20px;\n    transform: translate3d(-50%, -50%, 0);\n    transition: all 85ms ease-out;\n  }\n  svg:last-child {\n    opacity: 0;\n  }\n  *:hover > & {\n    svg:first-child {\n      opacity: 0;\n    }\n    svg:last-child {\n      opacity: 1;\n    }\n  }\n"], ["\n  margin: 0;\n  flex: 0 0 auto;\n  width: 32px;\n  position: relative;\n  fill: inherit;\n  padding: 12px 0;\n  transition: all 85ms ease-out;\n  &:hover {\n    background-color: #f6f6f9;\n    cursor: grab;\n  }\n  svg {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    width: 20px;\n    height: 20px;\n    transform: translate3d(-50%, -50%, 0);\n    transition: all 85ms ease-out;\n  }\n  svg:last-child {\n    opacity: 0;\n  }\n  *:hover > & {\n    svg:first-child {\n      opacity: 0;\n    }\n    svg:last-child {\n      opacity: 1;\n    }\n  }\n"])),
      bt = function bt(n) {
    var e = n.setExpanded,
        t = n.isExpanded,
        r = n.tinaForm,
        o = n.field,
        i = n.index,
        a = n.itemTitle,
        l = p.useMemo(function () {
      return o.fields.map(function (n) {
        return _v(_v({}, n), {
          name: o.name + "." + i + "." + n.name
        });
      });
    }, [o.fields, o.name, i]);
    return p.createElement(Cn, {
      isExpanded: t
    }, p.createElement(kn, {
      onClick: function onClick() {
        return e(!1);
      }
    }, p.createElement(u.LeftArrowIcon, null), p.createElement(dt, null, a)), p.createElement(En, null, t ? p.createElement(c.FieldsBuilder, {
      form: r,
      fields: l
    }) : null));
  },
      xt = {
    name: "group-list",
    Component: function Component(n) {
      var t = n.tinaForm,
          e = n.form,
          r = n.field,
          o = n.input,
          i = p.useCallback(function () {
        var n = {};
        n = "function" == typeof r.defaultItem ? r.defaultItem() : r.defaultItem || {}, e.mutators.insert(r.name, 0, n);
      }, [e, r]),
          a = o.value || [],
          l = p.useCallback(function (n) {
        return r.itemProps ? r.itemProps(n) : {};
      }, [r.itemProps]);
      return p.createElement(p.Fragment, null, p.createElement(ct, null, p.createElement(dt, null, r.label || r.name), p.createElement(f.IconButton, {
        onClick: i,
        primary: !0,
        small: !0
      }, p.createElement(u.AddIcon, null))), p.createElement(pt, null, p.createElement(ft, null, p.createElement(g.Droppable, {
        droppableId: r.name,
        type: r.name
      }, function (n) {
        return p.createElement("div", {
          ref: n.innerRef
        }, 0 === a.length && p.createElement(at, null), a.map(function (n, e) {
          return p.createElement(lt, _v({
            tinaForm: t,
            field: r,
            item: n,
            index: e
          }, l(n)));
        }), n.placeholder);
      }))));
    }
  };

  function vt(n) {
    var i = this,
        a = n.activeForm,
        l = n.setActiveFormId,
        s = n.isMultiform,
        d = p.useCallback(function (n) {
      if (n.destination && a) {
        var e = n.type;
        a.mutators.move(e, n.source.index, n.destination.index);
      }
    }, [a]);
    return p.createElement(c.FormBuilder, {
      form: a
    }, function (n) {
      var e = n.handleSubmit,
          t = n.pristine,
          r = n.form,
          o = n.submitting;
      return p.createElement(g.DragDropContext, {
        onDragEnd: d
      }, s && p.createElement(_t, {
        activeForm: a,
        setActiveFormId: l
      }), p.createElement(Gt, null, p.createElement(Nt, null, a && (a.fields.length ? p.createElement(c.FieldsBuilder, {
        form: a,
        fields: a.fields
      }) : p.createElement(Rt, null)))), p.createElement(Lt, null, p.createElement(Nt, null, a.reset && p.createElement(hn, {
        pristine: t,
        reset: function reset() {
          return y(i, void 0, void 0, function () {
            return k(this, function (n) {
              switch (n.label) {
                case 0:
                  return r.reset(), [4, a.reset()];

                case 1:
                  return n.sent(), [2];
              }
            });
          });
        }
      }), p.createElement(f.Button, {
        onClick: function onClick() {
          return e();
        },
        disabled: t,
        busy: o,
        primary: !0,
        grow: !0,
        margin: !0
      }, o && p.createElement(Y, null), !o && "Save"), 0 < a.actions.length && p.createElement(O, {
        actions: a.actions,
        form: a
      }))));
    });
  }

  var wt,
      yt,
      kt,
      Et,
      Pt,
      zt,
      Ct,
      Ft,
      St,
      Ot,
      jt,
      It,
      Mt,
      Dt = t.span(wt = wt || E(["\n  font-size: 40px;\n  line-height: 1;\n  display: inline-block;\n"], ["\n  font-size: 40px;\n  line-height: 1;\n  display: inline-block;\n"])),
      Tt = l.keyframes(yt = yt || E(["\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n"], ["\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n"])),
      Bt = t.div(kt = kt || E(["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: ", " ", " 64px ", ";\n  width: 100%;\n  height: 100%;\n  overflow-y: auto;\n  animation-name: ", ";\n  animation-delay: 300ms;\n  animation-timing-function: ease-out;\n  animation-iteration-count: 1;\n  animation-fill-mode: both;\n  animation-duration: 150ms;\n  > *:first-child {\n    margin: 0 0 ", " 0;\n  }\n  > ", " {\n    display: block;\n  }\n  h3 {\n    font-size: ", ";\n    font-weight: normal;\n    color: inherit;\n    display: block;\n    margin: 0 0 ", " 0;\n    ", " {\n      font-size: 1em;\n    }\n  }\n  p {\n    display: block;\n    margin: 0 0 ", " 0;\n  }\n"], ["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: ", " ", " 64px ", ";\n  width: 100%;\n  height: 100%;\n  overflow-y: auto;\n  animation-name: ", ";\n  animation-delay: 300ms;\n  animation-timing-function: ease-out;\n  animation-iteration-count: 1;\n  animation-fill-mode: both;\n  animation-duration: 150ms;\n  > *:first-child {\n    margin: 0 0 ", " 0;\n  }\n  > ", " {\n    display: block;\n  }\n  h3 {\n    font-size: ", ";\n    font-weight: normal;\n    color: inherit;\n    display: block;\n    margin: 0 0 ", " 0;\n    ", " {\n      font-size: 1em;\n    }\n  }\n  p {\n    display: block;\n    margin: 0 0 ", " 0;\n  }\n"]), f.padding(), f.padding(), f.padding(), Tt, f.padding(), Dt, f.font.size(5), f.padding(), Dt, f.padding()),
      At = t.a(Et = Et || E(["\n  text-align: center;\n  border: 0;\n  border-radius: ", ";\n  border: 1px solid ", ";\n  box-shadow: ", ";\n  font-weight: 500;\n  cursor: pointer;\n  font-size: ", ";\n  transition: all ", " ease-out;\n  background-color: white;\n  color: ", ";\n  padding: ", " ", " ", " 56px;\n  position: relative;\n  text-decoration: none;\n  display: inline-block;\n  ", " {\n    font-size: 24px;\n    position: absolute;\n    left: ", ";\n    top: 50%;\n    transform-origin: 50% 50%;\n    transform: translate3d(0, -50%, 0);\n    transition: all ", " ease-out;\n  }\n  &:hover {\n    color: ", ";\n    ", " {\n      transform: translate3d(0, -50%, 0);\n    }\n  }\n"], ["\n  text-align: center;\n  border: 0;\n  border-radius: ", ";\n  border: 1px solid ", ";\n  box-shadow: ", ";\n  font-weight: 500;\n  cursor: pointer;\n  font-size: ", ";\n  transition: all ", " ease-out;\n  background-color: white;\n  color: ", ";\n  padding: ", " ", " ", " 56px;\n  position: relative;\n  text-decoration: none;\n  display: inline-block;\n  ", " {\n    font-size: 24px;\n    position: absolute;\n    left: ", ";\n    top: 50%;\n    transform-origin: 50% 50%;\n    transform: translate3d(0, -50%, 0);\n    transition: all ", " ease-out;\n  }\n  &:hover {\n    color: ", ";\n    ", " {\n      transform: translate3d(0, -50%, 0);\n    }\n  }\n"]), f.radius("big"), f.color.grey(2), f.shadow("small"), f.font.size(0), f.timing("short"), f.color.grey(8), f.padding("small"), f.padding("big"), f.padding("small"), Dt, f.padding("big"), f.timing("short"), f.color.primary(), Dt),
      qt = function qt() {
    return p.createElement(Bt, null, p.createElement(Dt, null, "👋"), p.createElement("h3", null, "Welcome to ", p.createElement("b", null, "Tina"), "!"), p.createElement("p", null, "Let's get a form set up", p.createElement("br", null), "so you can start editing."), p.createElement("p", null, p.createElement(At, {
      href: "https://tinacms.org/docs/getting-started/introduction/#get-started",
      target: "_blank"
    }, p.createElement(Dt, null, "📖"), " Form Setup Guide")));
  },
      Rt = function Rt() {
    return p.createElement(Bt, null, p.createElement(Dt, null, "🤔"), p.createElement("h3", null, "Hey, you don't have any fields added to this form."), p.createElement("p", null, p.createElement(At, {
      href: "https://tinacms.org/docs/gatsby/markdown/#creating-remark-forms",
      target: "_blank"
    }, p.createElement(Dt, null, "📖"), " Field Setup Guide")));
  },
      _t = t(function (n) {
    var e = n.activeForm,
        t = n.setActiveFormId,
        r = w(n, ["activeForm", "setActiveFormId"]);
    return p.createElement("div", _v({}, r, {
      onClick: function onClick() {
        return t();
      }
    }), p.createElement(u.LeftArrowIcon, null), p.createElement("span", null, e.label));
  })(Pt = Pt || E(["\n  position: relative;\n  width: 100%;\n  height: ", "px;\n  flex: 0 0 ", "px;\n  cursor: pointer;\n  background-color: white;\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  padding: 0 ", " ", " ", ";\n  color: inherit;\n  font-size: ", ";\n  transition: color 250ms ease-out;\n  user-select: none;\n  span {\n    flex: 1 1 auto;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n  svg {\n    flex: 0 0 auto;\n    width: 24px;\n    fill: ", ";\n    height: auto;\n    transform: translate3d(-4px, 0, 0);\n    transition: transform 150ms ease-out;\n  }\n  :hover {\n    color: ", ";\n    svg {\n      fill: ", ";\n      transform: translate3d(-7px, 0, 0);\n      transition: transform 250ms ease;\n    }\n  }\n"], ["\n  position: relative;\n  width: 100%;\n  height: ", "px;\n  flex: 0 0 ", "px;\n  cursor: pointer;\n  background-color: white;\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  padding: 0 ", " ", " ", ";\n  color: inherit;\n  font-size: ", ";\n  transition: color 250ms ease-out;\n  user-select: none;\n  span {\n    flex: 1 1 auto;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n  svg {\n    flex: 0 0 auto;\n    width: 24px;\n    fill: ", ";\n    height: auto;\n    transform: translate3d(-4px, 0, 0);\n    transition: transform 150ms ease-out;\n  }\n  :hover {\n    color: ", ";\n    svg {\n      fill: ", ";\n      transform: translate3d(-7px, 0, 0);\n      transition: transform 250ms ease;\n    }\n  }\n"]), 40, 40, f.padding(), f.padding("small"), f.padding(), f.font.size(5), f.color.grey(3), f.color.primary(), f.color.grey(8)),
      Nt = t.div(zt = zt || E(["\n  display: block;\n  margin: 0 auto;\n  max-width: 500px;\n  width: 100%;\n"], ["\n  display: block;\n  margin: 0 auto;\n  max-width: 500px;\n  width: 100%;\n"])),
      Gt = t.div(Ct = Ct || E(["\n  position: relative;\n  flex: 1 1 auto;\n  display: flex;\n  flex-direction: column;\n  scrollbar-width: none;\n  width: 100%;\n  overflow: hidden;\n  border-top: 1px solid ", ";\n  background-color: #f6f6f9;\n\n  ", " {\n    height: 100%;\n    scrollbar-width: none;\n  }\n"], ["\n  position: relative;\n  flex: 1 1 auto;\n  display: flex;\n  flex-direction: column;\n  scrollbar-width: none;\n  width: 100%;\n  overflow: hidden;\n  border-top: 1px solid ", ";\n  background-color: #f6f6f9;\n\n  ", " {\n    height: 100%;\n    scrollbar-width: none;\n  }\n"]), f.color.grey(2), Nt),
      Lt = t.div(Ft = Ft || E(["\n  position: relative;\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 64px;\n  background-color: white;\n  border-top: 1px solid ", ";\n\n  ", " {\n    flex: 1 0 auto;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0 16px;\n  }\n"], ["\n  position: relative;\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 64px;\n  background-color: white;\n  border-top: 1px solid ", ";\n\n  ", " {\n    flex: 1 0 auto;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0 16px;\n  }\n"]), f.color.grey(2), Nt),
      Ht = l.keyframes(St = St || E(["\n  0% {\n    transform: translate3d( 100%, 0, 0 );\n  }\n  100% {\n    transform: translate3d( 0, 0, 0 );\n  }\n"], ["\n  0% {\n    transform: translate3d( 100%, 0, 0 );\n  }\n  100% {\n    transform: translate3d( 0, 0, 0 );\n  }\n"])),
      Yt = t.div(It = It || E(["\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  overflow: hidden;\n  height: 100%;\n  width: 100%;\n  position: relative;\n\n  ", ", ", ", ", " {\n    transform: translate3d(100%, 0, 0);\n  }\n\n  ", ";\n\n  ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  overflow: hidden;\n  height: 100%;\n  width: 100%;\n  position: relative;\n\n  ", ", ", ", ", " {\n    transform: translate3d(100%, 0, 0);\n  }\n\n  ", ";\n\n  ", ";\n"]), _t, Gt, Lt, function (n) {
    return n.isEditing && l.css(Ot = Ot || E(["\n      ", ", ", ", ", " {\n        transform: none;\n        animation-name: ", ";\n        animation-duration: 150ms;\n        animation-delay: 0;\n        animation-iteration-count: 1;\n        animation-timing-function: ease-out;\n      }\n    "], ["\n      ", ", ", ", ", " {\n        transform: none;\n        animation-name: ", ";\n        animation-duration: 150ms;\n        animation-delay: 0;\n        animation-iteration-count: 1;\n        animation-timing-function: ease-out;\n      }\n    "]), _t, Gt, Lt, Ht);
  }, function (n) {
    return n.isMultiform && l.css(jt = jt || E(["\n      ", " {\n        top: ", "px;\n      }\n    "], ["\n      ", " {\n        top: ", "px;\n      }\n    "]), Cn, 100);
  }),
      Kt = (t(f.Button)(Mt = Mt || E(["\n  flex: 1.5 0 auto;\n  padding: 12px 24px;\n"], ["\n  flex: 1.5 0 auto;\n  padding: 12px 24px;\n"])), function (n, e, t) {
    this.form = n, this.__type = "screen", this.name = n.label, this.Icon = e || u.SettingsIcon, this.layout = t || "popup", this.Component = function () {
      return p.createElement(vt, {
        activeForm: n,
        isMultiform: !1,
        setActiveFormId: null
      });
    };
  });

  function Wt() {
    var n = h(),
        e = p.useState(!1),
        t = e[0],
        r = e[1],
        o = n.plugins.findOrCreateMap("content-creator");
    return d.useSubscribable(o), o.all().length ? p.createElement(xr, null, p.createElement(f.IconButton, {
      onClick: function onClick() {
        return r(!0);
      },
      open: t,
      primary: !0
    }, p.createElement(u.AddIcon, null)), p.createElement(vr, {
      open: t
    }, p.createElement(m.Dismissible, {
      click: !0,
      escape: !0,
      onDismiss: function onDismiss() {
        return r(!1);
      },
      disabled: !t
    }, o.all().map(function (n) {
      return p.createElement(hr, {
        plugin: n,
        key: n.name,
        onClick: function onClick() {
          r(!1);
        }
      });
    })))) : null;
  }

  function Vt() {
    var n = h();
    d.useSubscribable(n.sidebar), d.useSubscribable(n.screens);
    var e = p.useState(!1),
        t = e[0],
        r = e[1],
        o = p.useState(null),
        i = o[0],
        a = o[1],
        l = n.screens.all(),
        s = 0 < l.length;
    return p.createElement(Dr, {
      open: n.sidebar.isOpen
    }, p.createElement(Mr, {
      open: n.sidebar.isOpen
    }, p.createElement(Cr, null, s && p.createElement(Fr, {
      onClick: function onClick() {
        return r(!t);
      },
      open: t
    }, p.createElement(u.HamburgerIcon, null)), p.createElement(Wt, null)), p.createElement(be, null), s && p.createElement(Or, {
      visible: t
    }, p.createElement(Sr, null, p.createElement(Pr, null, l.map(function (n) {
      var e = n.Icon;
      return p.createElement(zr, {
        value: n.name,
        onClick: function onClick() {
          a(n), r(!1);
        }
      }, p.createElement(e, null), " ", n.name);
    }))), p.createElement(kr, null)), i && p.createElement(yr, {
      name: i.name,
      close: function close() {
        return a(null);
      },
      layout: i.layout
    }, p.createElement(i.Component, null))), p.createElement(Er, {
      sidebar: n.sidebar
    }));
  }

  function Ut(n) {
    var e = n.cms,
        t = n.children,
        r = n.hidden,
        o = n.position,
        i = n.theme;
    d.useSubscribable(e.sidebar);
    var a = p.useMemo(function () {
      return {
        tinacms: Tr(f.DefaultTheme, e.sidebar.theme, i)
      };
    }, [f.DefaultTheme, i]);
    return void 0 === r && (r = e.sidebar.hidden), p.createElement(d.CMSContext.Provider, {
      value: e
    }, p.createElement(Br, {
      open: e.sidebar.isOpen,
      position: o || e.sidebar.position
    }, t), !r && p.createElement(l.ThemeProvider, {
      theme: a
    }, p.createElement(A, null, p.createElement(f.TinaReset, null, p.createElement(Vt, null)))));
  }

  var Jt,
      Qt,
      Xt,
      Zt,
      $t,
      nr,
      er,
      tr,
      rr,
      or,
      ir,
      ar,
      lr,
      sr,
      dr,
      cr,
      pr,
      ur,
      fr,
      mr = l.keyframes(Jt = Jt || E(["\n  0% {\n    transform: translate3d( -2rem, 0, 0 );\n    opacity: 0;\n  }\n\n  100% {\n    transform: translate3d( 0, 0, 0 );\n    opacity: 1;\n  }\n"], ["\n  0% {\n    transform: translate3d( -2rem, 0, 0 );\n    opacity: 0;\n  }\n\n  100% {\n    transform: translate3d( 0, 0, 0 );\n    opacity: 1;\n  }\n"])),
      gr = t.div(Qt = Qt || E(["\n  display: flex;\n  flex-direction: column;\n  z-index: 1;\n  overflow: visible;\n  background-color: #fff;\n  border-radius: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: calc(100% - 170px);\n  max-width: 1500px;\n  height: 100%;\n  animation: ", " 150ms ease-out 1;\n\n  ", " {\n    flex: 1 0 auto;\n    display: flex;\n    flex-direction: column;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  z-index: 1;\n  overflow: visible;\n  background-color: #fff;\n  border-radius: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: calc(100% - 170px);\n  max-width: 1500px;\n  height: 100%;\n  animation: ", " 150ms ease-out 1;\n\n  ", " {\n    flex: 1 0 auto;\n    display: flex;\n    flex-direction: column;\n  }\n"]), mr, un),
      hr = function hr(n) {
    var e = n.plugin,
        t = n.onClick,
        r = p.useState(!1),
        o = r[0],
        i = r[1];
    return p.createElement(p.Fragment, null, p.createElement(wr, {
      onClick: function onClick() {
        i(function (n) {
          return !n;
        }), t();
      }
    }, e.name), o && p.createElement(br, {
      plugin: e,
      close: function close() {
        return i(!1);
      }
    }));
  },
      br = function br(n) {
    var t = n.plugin,
        r = n.close,
        e = h(),
        o = p.useMemo(function () {
      return new a.Form({
        label: "create-form",
        id: "create-form-id",
        actions: [],
        fields: t.fields,
        onSubmit: function onSubmit(n) {
          t.onSubmit(n, e).then(function () {
            r();
          });
        }
      });
    }, [r, e, t]);
    return p.createElement(Q, null, p.createElement(c.FormBuilder, {
      form: o
    }, function (n) {
      var e = n.handleSubmit;
      return p.createElement(gn, null, p.createElement(pn, {
        close: r
      }, t.name), p.createElement(un, {
        onKeyPress: function onKeyPress(n) {
          return 13 === n.charCode ? e() : null;
        }
      }, p.createElement(c.FieldsBuilder, {
        form: o,
        fields: o.fields
      })), p.createElement(fn, null, p.createElement(f.Button, {
        onClick: r
      }, "Cancel"), p.createElement(f.Button, {
        onClick: e,
        primary: !0
      }, "Create")));
    }));
  },
      xr = t.div(Xt = Xt || E(["\n  position: relative;\n"], ["\n  position: relative;\n"])),
      vr = t.div($t = $t || E(["\n  min-width: 192px;\n  border-radius: ", ";\n  border: 1px solid ", ";\n  display: block;\n  position: absolute;\n  top: 0;\n  right: 0;\n  transform: translate3d(0, 0, 0) scale3d(0.5, 0.5, 1);\n  opacity: 0;\n  pointer-events: none;\n  transition: all 150ms ease-out;\n  transform-origin: 100% 0;\n  box-shadow: ", ";\n  background-color: white;\n  overflow: hidden;\n  z-index: 100;\n\n  ", ";\n"], ["\n  min-width: 192px;\n  border-radius: ", ";\n  border: 1px solid ", ";\n  display: block;\n  position: absolute;\n  top: 0;\n  right: 0;\n  transform: translate3d(0, 0, 0) scale3d(0.5, 0.5, 1);\n  opacity: 0;\n  pointer-events: none;\n  transition: all 150ms ease-out;\n  transform-origin: 100% 0;\n  box-shadow: ", ";\n  background-color: white;\n  overflow: hidden;\n  z-index: 100;\n\n  ", ";\n"]), f.radius(), f.color.grey(2), f.shadow("big"), function (n) {
    return n.open && l.css(Zt = Zt || E(["\n      opacity: 1;\n      pointer-events: all;\n      transform: translate3d(0, 44px, 0) scale3d(1, 1, 1);\n    "], ["\n      opacity: 1;\n      pointer-events: all;\n      transform: translate3d(0, 44px, 0) scale3d(1, 1, 1);\n    "]));
  }),
      wr = t.button(nr = nr || E(["\n  position: relative;\n  text-align: center;\n  font-size: ", ";\n  padding: 0 12px;\n  height: 40px;\n  font-weight: 500;\n  width: 100%;\n  background: none;\n  cursor: pointer;\n  outline: none;\n  border: 0;\n  transition: all 85ms ease-out;\n  &:hover {\n    color: ", ";\n    background-color: #f6f6f9;\n  }\n  &:not(:last-child) {\n    border-bottom: 1px solid #efefef;\n  }\n"], ["\n  position: relative;\n  text-align: center;\n  font-size: ", ";\n  padding: 0 12px;\n  height: 40px;\n  font-weight: 500;\n  width: 100%;\n  background: none;\n  cursor: pointer;\n  outline: none;\n  border: 0;\n  transition: all 85ms ease-out;\n  &:hover {\n    color: ", ";\n    background-color: #f6f6f9;\n  }\n  &:not(:last-child) {\n    border-bottom: 1px solid #efefef;\n  }\n"]), f.font.size(0), f.color.primary()),
      yr = function yr(n) {
    var e,
        t = n.children,
        r = n.name,
        o = n.close;

    switch (n.layout) {
      case "popup":
        e = gn;
        break;

      case "fullscreen":
        e = gr;
        break;

      default:
        e = gn;
    }

    return p.createElement(Q, null, p.createElement(e, null, p.createElement(pn, {
      close: o
    }, r), p.createElement(un, null, t)));
  },
      kr = t(function (n) {
    var e = w(n, []);
    return p.createElement("div", _v({}, e), p.createElement(u.TinaIcon, null));
  })(er = er || E(["\n  position: absolute;\n  z-index: -1;\n  bottom: ", ";\n  left: ", ";\n  svg {\n    width: 128px;\n    height: 128px;\n    margin: -4px -20px;\n    fill: ", ";\n  }\n"], ["\n  position: absolute;\n  z-index: -1;\n  bottom: ", ";\n  left: ", ";\n  svg {\n    width: 128px;\n    height: 128px;\n    margin: -4px -20px;\n    fill: ", ";\n  }\n"]), f.padding(), f.padding(), f.color.grey(9)),
      Er = function Er(n) {
    var e = n.sidebar;
    return p.createElement(Ir, {
      onClick: function onClick() {
        return e.isOpen = !e.isOpen;
      },
      open: e.isOpen
    }, e.isOpen ? p.createElement(u.LeftArrowIcon, null) : p.createElement(u.EditIcon, null));
  },
      Pr = t.div(tr = tr || E(["\n  margin: 32px -", " 32px -", ";\n  display: block;\n"], ["\n  margin: 32px -", " 32px -", ";\n  display: block;\n"]), f.padding(), f.padding()),
      zr = t.div(rr = rr || E(["\n  color: ", ";\n  font-size: ", ";\n  font-weight: 500;\n  padding: ", " ", " ", " 64px;\n  position: relative;\n  cursor: pointer;\n  transition: all ", " ease-out;\n  overflow: hidden;\n  &:after {\n    content: '';\n    position: absolute;\n    top: 8px;\n    bottom: 8px;\n    left: 8px;\n    right: 8px;\n    border-radius: ", ";\n    background-color: ", ";\n    z-index: -1;\n    transition: all 150ms ease;\n    transform: translate3d(0, 100%, 0);\n    opacity: 0;\n  }\n  &:hover {\n    color: ", ";\n    &:after {\n      transform: translate3d(0, 0, 0);\n      transition: transform ", " ease-out, opacity 0ms;\n      opacity: 1;\n    }\n    svg {\n      fill: ", ";\n    }\n    & ~ * {\n      &:after {\n        transform: translate3d(0, -100%, 0);\n      }\n    }\n  }\n  svg {\n    position: absolute;\n    left: ", ";\n    top: 50%;\n    transform: translate3d(0, -50%, 0);\n    width: 36px;\n    height: auto;\n    fill: ", ";\n    transition: all ", " ease-out;\n  }\n"], ["\n  color: ", ";\n  font-size: ", ";\n  font-weight: 500;\n  padding: ", " ", " ", " 64px;\n  position: relative;\n  cursor: pointer;\n  transition: all ", " ease-out;\n  overflow: hidden;\n  &:after {\n    content: '';\n    position: absolute;\n    top: 8px;\n    bottom: 8px;\n    left: 8px;\n    right: 8px;\n    border-radius: ", ";\n    background-color: ", ";\n    z-index: -1;\n    transition: all 150ms ease;\n    transform: translate3d(0, 100%, 0);\n    opacity: 0;\n  }\n  &:hover {\n    color: ", ";\n    &:after {\n      transform: translate3d(0, 0, 0);\n      transition: transform ", " ease-out, opacity 0ms;\n      opacity: 1;\n    }\n    svg {\n      fill: ", ";\n    }\n    & ~ * {\n      &:after {\n        transform: translate3d(0, -100%, 0);\n      }\n    }\n  }\n  svg {\n    position: absolute;\n    left: ", ";\n    top: 50%;\n    transform: translate3d(0, -50%, 0);\n    width: 36px;\n    height: auto;\n    fill: ", ";\n    transition: all ", " ease-out;\n  }\n"]), f.color.grey(1), f.font.size(4), f.padding(), f.padding(), f.padding(), f.timing("short"), f.radius(), f.color.grey(9), f.color.primary("light"), f.timing("short"), f.color.primary(), f.padding(), f.color.grey(4), f.timing("short")),
      Cr = t.div(or = or || E(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  z-index: 1050;\n  flex: 0 0 ", "px;\n  height: ", "px;\n  width: 100%;\n  padding: 0 ", ";\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  z-index: 1050;\n  flex: 0 0 ", "px;\n  height: ", "px;\n  width: 100%;\n  padding: 0 ", ";\n"]), 60, 60, f.padding()),
      Fr = t.button(ar = ar || E(["\n  padding: 0 0 0 ", ";\n  margin-left: -", ";\n  background: transparent;\n  outline: none;\n  border: 0;\n  text-align: left;\n  width: 64px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  svg {\n    position: relative;\n    transition: fill 85ms ease-out;\n    fill: ", ";\n    margin-left: -4px;\n    width: 32px;\n    height: auto;\n    path {\n      position: relative;\n      transition: transform 250ms ease-out, opacity 250ms ease-out,\n        fill 85ms ease-out;\n      transform-origin: 50% 50%;\n    }\n  }\n  &:hover {\n    svg {\n      fill: ", ";\n    }\n  }\n  ", ";\n"], ["\n  padding: 0 0 0 ", ";\n  margin-left: -", ";\n  background: transparent;\n  outline: none;\n  border: 0;\n  text-align: left;\n  width: 64px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  svg {\n    position: relative;\n    transition: fill 85ms ease-out;\n    fill: ", ";\n    margin-left: -4px;\n    width: 32px;\n    height: auto;\n    path {\n      position: relative;\n      transition: transform 250ms ease-out, opacity 250ms ease-out,\n        fill 85ms ease-out;\n      transform-origin: 50% 50%;\n    }\n  }\n  &:hover {\n    svg {\n      fill: ", ";\n    }\n  }\n  ", ";\n"]), f.padding(), f.padding(), f.color.grey(6), f.color.grey(7), function (n) {
    return n.open && l.css(ir = ir || E(["\n      svg {\n        fill: #f6f6f9;\n        &:hover {\n          fill: ", ";\n        }\n        path:first-child {\n          /* Top bar */\n          transform: rotate(45deg) translate3d(0, 0.45rem, 0);\n        }\n        path:nth-child(2) {\n          /* Middle bar */\n          transform: translate3d(-100%, 0, 0);\n          opacity: 0;\n        }\n        path:last-child {\n          /* Bottom Bar */\n          transform: rotate(-45deg) translate3d(0, -0.45rem, 0);\n        }\n      }\n    "], ["\n      svg {\n        fill: #f6f6f9;\n        &:hover {\n          fill: ", ";\n        }\n        path:first-child {\n          /* Top bar */\n          transform: rotate(45deg) translate3d(0, 0.45rem, 0);\n        }\n        path:nth-child(2) {\n          /* Middle bar */\n          transform: translate3d(-100%, 0, 0);\n          opacity: 0;\n        }\n        path:last-child {\n          /* Bottom Bar */\n          transform: rotate(-45deg) translate3d(0, -0.45rem, 0);\n        }\n      }\n    "]), f.color.grey(2));
  }),
      Sr = t.div(lr = lr || E(["\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n  padding: ", "px ", " ", " ", ";\n  ul,\n  li {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n  }\n"], ["\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n  padding: ", "px ", " ", " ", ";\n  ul,\n  li {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n  }\n"]), 60, f.padding(), f.padding(), f.padding()),
      Or = t.div(sr = sr || E(["\n  background: ", ";\n  z-index: 1000;\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: ", "px;\n  transform: translate3d(", ", 0, 0);\n  overflow: hidden;\n  padding: ", ";\n  transition: all 250ms ease-out;\n  ul,\n  li {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n  }\n"], ["\n  background: ", ";\n  z-index: 1000;\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: ", "px;\n  transform: translate3d(", ", 0, 0);\n  overflow: hidden;\n  padding: ", ";\n  transition: all 250ms ease-out;\n  ul,\n  li {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n  }\n"]), f.color.grey(8), V, function (n) {
    return n.visible ? "0" : "-100%";
  }, f.padding()),
      jr = l.keyframes(dr = dr || E(["\n  from {\n    transform: translate3d(-100%,0,0);\n  }\n\n  to {\n    transform: translate3d(0,0,0);\n  }\n"], ["\n  from {\n    transform: translate3d(-100%,0,0);\n  }\n\n  to {\n    transform: translate3d(0,0,0);\n  }\n"])),
      Ir = t.button(cr = cr || E(["\n  position: absolute;\n  pointer-events: all;\n  bottom: 44px;\n  left: ", "px;\n  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 2px 6px rgba(0, 0, 0, 0.2);\n  border-radius: 0 24px 24px 0;\n  width: 50px;\n  height: 44px;\n  border: 0;\n  outline: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  fill: white;\n  text-align: center;\n  background-color: ", ";\n  background-repeat: no-repeat;\n  background-position: center;\n  transition: all 150ms ease-out;\n  cursor: pointer;\n  animation: ", " 200ms 300ms ease-out 1 both;\n  &:hover {\n    background-color: ", ";\n  }\n  &:active {\n    background-color: ", ";\n  }\n"], ["\n  position: absolute;\n  pointer-events: all;\n  bottom: 44px;\n  left: ", "px;\n  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 2px 6px rgba(0, 0, 0, 0.2);\n  border-radius: 0 24px 24px 0;\n  width: 50px;\n  height: 44px;\n  border: 0;\n  outline: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  fill: white;\n  text-align: center;\n  background-color: ", ";\n  background-repeat: no-repeat;\n  background-position: center;\n  transition: all 150ms ease-out;\n  cursor: pointer;\n  animation: ", " 200ms 300ms ease-out 1 both;\n  &:hover {\n    background-color: ", ";\n  }\n  &:active {\n    background-color: ", ";\n  }\n"]), V, f.color.primary(), jr, f.color.primary("light"), f.color.primary("dark")),
      Mr = t.div(pr = pr || E(["\n  margin: 0;\n  padding: 0;\n  border: 0;\n  z-index: 1;\n  background-color: white;\n  position: fixed;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  width: ", "px;\n  overflow: visible;\n  height: 100%;\n  left: 0;\n  top: 0;\n\n  &:before,\n  &:after {\n    content: '';\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n  }\n  &:before {\n    /* Animate box-shadow with opacity for better performance */\n    box-shadow: 0 0 3px rgba(0, 0, 0, 0.07), 2px 0 8px rgba(0, 0, 0, 0.07);\n    transition: all ", "ms ease-out;\n    opacity: ", ";\n  }\n  &:after {\n    /* Overlay outer border */\n    border-right: 1px solid rgba(51, 51, 51, 0.09);\n  }\n"], ["\n  margin: 0;\n  padding: 0;\n  border: 0;\n  z-index: 1;\n  background-color: white;\n  position: fixed;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  width: ", "px;\n  overflow: visible;\n  height: 100%;\n  left: 0;\n  top: 0;\n\n  &:before,\n  &:after {\n    content: '';\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n  }\n  &:before {\n    /* Animate box-shadow with opacity for better performance */\n    box-shadow: 0 0 3px rgba(0, 0, 0, 0.07), 2px 0 8px rgba(0, 0, 0, 0.07);\n    transition: all ", "ms ease-out;\n    opacity: ", ";\n  }\n  &:after {\n    /* Overlay outer border */\n    border-right: 1px solid rgba(51, 51, 51, 0.09);\n  }\n"]), V, function (n) {
    return n.open ? 150 : 200;
  }, function (n) {
    return n.open ? 1 : 0;
  }),
      Dr = t.div(ur = ur || E(["\n  position: fixed !important;\n  top: 0 !important;\n  left: 0 !important;\n  display: block !important;\n  background: transparent !important;\n  height: 100% !important;\n  width: ", "px !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  border: 0 !important;\n  z-index: ", " !important;\n  transition: all ", "ms ease-out !important;\n  transform: translate3d(\n    ", ",\n    0,\n    0\n  ) !important;\n  pointer-events: ", ";\n"], ["\n  position: fixed !important;\n  top: 0 !important;\n  left: 0 !important;\n  display: block !important;\n  background: transparent !important;\n  height: 100% !important;\n  width: ", "px !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  border: 0 !important;\n  z-index: ", " !important;\n  transition: all ", "ms ease-out !important;\n  transform: translate3d(\n    ", ",\n    0,\n    0\n  ) !important;\n  pointer-events: ", ";\n"]), V, 2147e6, function (n) {
    return n.open ? 150 : 200;
  }, function (n) {
    return n.open ? "0" : "-340px";
  }, function (n) {
    return n.open ? "all" : "none";
  }),
      Tr = require("lodash.merge"),
      Br = t.div(fr = fr || E(["\n  opacity: 1 !important;\n  background-color: transparent !important;\n  background-image: none !important;\n  overflow: visible !important;\n  position: absolute !important;\n  top: 0 !important;\n  right: 0 !important;\n  height: 100% !important;\n  width: ", " !important;\n  transition: all ", "ms ease-out !important;\n"], ["\n  opacity: 1 !important;\n  background-color: transparent !important;\n  background-image: none !important;\n  overflow: visible !important;\n  position: absolute !important;\n  top: 0 !important;\n  right: 0 !important;\n  height: 100% !important;\n  width: ", " !important;\n  transition: all ", "ms ease-out !important;\n"]), function (n) {
    return function (n) {
      return "fixed" === n || "displace" === n;
    }(n.position) && n.open ? "calc(100% - 340px)" : "100%";
  }, function (n) {
    return n.open ? 150 : 200;
  });

  var Ar,
      qr = {
    name: "image",
    Component: me(function (t) {
      var r = h();
      return p.createElement(o.ImageUpload, {
        value: t.input.value,
        previewSrc: t.field.previewSrc(t.form.getState().values, t),
        onDrop: function onDrop(n) {
          n.forEach(function (e) {
            return y(void 0, void 0, void 0, function () {
              return k(this, function (n) {
                switch (n.label) {
                  case 0:
                    return [4, r.api.git.onUploadMedia({
                      directory: t.field.uploadDir(t.form.getState().values),
                      content: e
                    })];

                  case 1:
                    return n.sent(), t.input.onChange(e.name), [2];
                }
              });
            });
          });
        },
        onClear: !1 === t.field.clearable ? void 0 : function () {
          t.input.onChange("");
        }
      });
    }),
    parse: he
  },
      Rr = (x(_r, Ar = n.CMS), Object.defineProperty(_r.prototype, "forms", {
    get: function get() {
      return this.plugins.findOrCreateMap("form");
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(_r.prototype, "fields", {
    get: function get() {
      return this.plugins.findOrCreateMap("field");
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(_r.prototype, "screens", {
    get: function get() {
      return this.plugins.findOrCreateMap("screen");
    },
    enumerable: !0,
    configurable: !0
  }), _r);

  function _r(n) {
    var e = n.sidebar,
        t = w(n, ["sidebar"]),
        r = Ar.call(this, t) || this;
    return r.sidebar = new Gr(e), r.fields.add(Ne), r.fields.add(We), r.fields.add(it), r.fields.add(qr), r.fields.add(Qe), r.fields.add(Ue), r.fields.add(Ze), r.fields.add(nt), r.fields.add(Ye), r.fields.add(Qn), r.fields.add(xt), r.fields.add(fe), r;
  }

  var Nr,
      Gr = (x(Lr, Nr = n.Subscribable), Object.defineProperty(Lr.prototype, "isOpen", {
    get: function get() {
      return this._isOpen;
    },
    set: function set(n) {
      this._isOpen = n, this.notifiySubscribers();
    },
    enumerable: !0,
    configurable: !0
  }), Lr);

  function Lr(n) {
    void 0 === n && (n = {});
    var e = Nr.call(this) || this;
    return e._isOpen = !1, e.position = "displace", e.hidden = !1, e.position = n.position || "displace", e.hidden = !!n.hidden, e.theme = n.theme, e;
  }

  Object.keys(c).forEach(function (n) {
    "default" !== n && Object.defineProperty(e, n, {
      enumerable: !0,
      get: function get() {
        return c[n];
      }
    });
  }), Object.defineProperty(e, "CMSContext", {
    enumerable: !0,
    get: function get() {
      return d.CMSContext;
    }
  }), Object.defineProperty(e, "ERROR_MISSING_CMS", {
    enumerable: !0,
    get: function get() {
      return d.ERROR_MISSING_CMS;
    }
  }), Object.defineProperty(e, "useForm", {
    enumerable: !0,
    get: function get() {
      return d.useForm;
    }
  }), Object.defineProperty(e, "useLocalForm", {
    enumerable: !0,
    get: function get() {
      return d.useLocalForm;
    }
  }), Object.defineProperty(e, "usePlugin", {
    enumerable: !0,
    get: function get() {
      return d.usePlugin;
    }
  }), Object.defineProperty(e, "usePlugins", {
    enumerable: !0,
    get: function get() {
      return d.usePlugins;
    }
  }), Object.defineProperty(e, "useSubscribable", {
    enumerable: !0,
    get: function get() {
      return d.useSubscribable;
    }
  }), Object.defineProperty(e, "useWatchFormValues", {
    enumerable: !0,
    get: function get() {
      return d.useWatchFormValues;
    }
  }), Object.defineProperty(e, "withPlugin", {
    enumerable: !0,
    get: function get() {
      return d.withPlugin;
    }
  }), Object.defineProperty(e, "withPlugins", {
    enumerable: !0,
    get: function get() {
      return d.withPlugins;
    }
  }), Object.defineProperty(e, "Input", {
    enumerable: !0,
    get: function get() {
      return o.Input;
    }
  }), Object.defineProperty(e, "NumberInput", {
    enumerable: !0,
    get: function get() {
      return o.NumberInput;
    }
  }), Object.defineProperty(e, "Select", {
    enumerable: !0,
    get: function get() {
      return o.Select;
    }
  }), Object.defineProperty(e, "Toggle", {
    enumerable: !0,
    get: function get() {
      return o.Toggle;
    }
  }), Object.defineProperty(e, "Wysiwyg", {
    enumerable: !0,
    get: function get() {
      return o.Wysiwyg;
    }
  }), Object.defineProperty(e, "Form", {
    enumerable: !0,
    get: function get() {
      return a.Form;
    }
  }), e.ActionButton = M, e.CMS = Rr, e.ColorField = Je, e.DateField = rt, e.FieldMeta = ge, e.GlobalFormPlugin = Kt, e.Group = X, e.GroupField = function (n) {
    return p.createElement("div", null, "Subfield: ", n.field.label || n.field.name);
  }, e.GroupPanel = Cn, e.MarkdownField = He, e.Modal = Q, e.ModalActions = fn, e.ModalBody = un, e.ModalFullscreen = gr, e.ModalHeader = pn, e.ModalOverlay = sn, e.ModalPopup = gn, e.ModalProvider = A, e.NumberField = Ve, e.PanelBody = En, e.PanelHeader = kn, e.SelectField = $e, e.TextField = _e, e.TextareaField = Ke, e.Tina = Ut, e.TinaCMS = Rr, e.ToggleField = Xe, e.useCMS = h, e.useGlobalForm = function (n, e) {
    void 0 === e && (e = {});
    var t = d.useForm(n, e),
        r = t[0],
        o = t[1],
        i = p.useMemo(function () {
      if (o) return new Kt(o);
    }, [o]);
    return d.usePlugins(i), [r, o];
  }, e.useModalContainer = J, e.useSidebar = function () {
    var n = h().sidebar;
    return d.useSubscribable(n), n;
  }, e.withTina = function (r, o) {
    return function (n) {
      var e = p.useMemo(function () {
        return function (n) {
          return require("lodash.merge")({
            plugins: [],
            apis: {},
            sidebar: {
              position: "displace",
              hidden: !1,
              theme: {}
            }
          }, require("lodash.clonedeep")(n));
        }(o);
      }, [o]),
          t = p.useMemo(function () {
        return new Rr(e);
      }, [e]);
      return p.createElement(Ut, _v({
        cms: t
      }, e.sidebar), p.createElement(r, _v({}, n)));
    };
  }, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});